var _rect, _rect2, _rect3, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcashLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7942_24555)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 3,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 3,
    fill: "#4573FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7942_24555",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 50
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 3,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7942_24555)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2859 9.08194C30.6674 9.29637 29.1601 9.7298 27.7859 10.6433C26.7044 11.3623 25.7655 12.3166 25.0479 13.3948C24.3699 14.4135 23.9116 15.5478 23.6581 16.741C23.4174 17.8742 23.3883 19.0141 23.5523 20.1585C24.5074 26.8222 31.9826 30.3855 37.8574 27.2939C38.3657 27.0264 39.044 26.6886 39.3786 26.2075C39.7874 25.6196 39.5204 24.771 38.8574 24.5121C38.1206 24.2244 37.5126 24.872 36.9288 25.2127C35.9812 25.7656 34.8849 26.1289 33.7859 26.2039C28.3592 26.5747 24.3449 21.1522 26.1927 16.1003C27.4736 12.5986 31.4204 10.6069 35.0002 11.4991C35.7856 11.6949 36.5273 12.0313 37.2145 12.456C37.7753 12.8025 38.3056 13.2737 38.9991 12.9186C40.3858 12.2087 39.0505 10.9291 38.2859 10.4622C36.5443 9.39878 34.3338 8.81064 32.2859 9.08194Z",
    fill: "#0330BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8573 12.1511C43.1601 12.3166 42.8642 13.0386 43.0791 13.6794C43.2664 14.2381 43.5804 14.7496 43.7548 15.3169C44.312 17.1297 44.4526 19.003 44.0994 20.8703C43.8908 21.9727 43.1746 22.9986 43.0154 24.0742C42.9022 24.8387 43.5094 25.4766 44.2859 25.3622C45.2761 25.2164 45.6139 23.7347 45.8811 22.9351C46.7504 20.3336 46.7454 17.5157 45.9901 14.8897C45.7236 13.9635 45.182 11.8366 43.8573 12.1511ZM32.3335 12.6351L32.3811 12.6589L32.3335 12.6351Z",
    fill: "#6EB9F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4287 12.6118V12.683H32.7144L32.4287 12.6118Z",
    fill: "#9DCDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9283 19.8739C36.0331 23.6307 30.5937 23.3578 29.4654 19.9451C28.6716 17.5439 30.5436 14.9281 33.0712 14.8217C34.11 14.778 34.8318 15.4943 35.7855 15.5879C36.5413 15.662 37.1442 14.8929 36.9323 14.1781C36.6163 13.1118 34.8003 12.7845 33.8569 12.672C30.8731 12.3158 27.9961 14.2549 27.2482 17.1684C25.8869 22.4721 31.8464 26.8109 36.4998 23.9275C37.2066 23.4896 37.7981 22.9035 38.2708 22.2235C38.8918 21.3302 39.9662 19.0154 39.0551 18.0303C38.6848 17.6298 38.2148 17.6668 37.7141 17.6668H34.7855C34.2148 17.6668 33.6849 17.6804 33.3633 18.2367C33.0256 18.8208 33.3246 19.522 33.9283 19.7684C34.7581 20.107 36.0401 19.8739 36.9283 19.8739Z",
    fill: "#FEFEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6431 12.6118V12.683H33.9288L33.6431 12.6118Z",
    fill: "#9DCDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9762 12.6353L34.0238 12.659L33.9762 12.6353ZM31.9048 12.7065L31.9524 12.7302L31.9048 12.7065Z",
    fill: "#6EB9F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0479 12.7065L32.0954 12.7303L32.0479 12.7065ZM34.2621 12.7065L34.3097 12.7303L34.2621 12.7065Z",
    fill: "#9DCDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4046 12.7065L34.4522 12.7303L34.4046 12.7065ZM31.5713 12.754L31.6427 12.8252L31.5713 12.754Z",
    fill: "#6EB9F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6904 12.7778L31.738 12.8016L31.6904 12.7778ZM34.619 12.7778L34.6666 12.8016L34.619 12.7778Z",
    fill: "#9DCDFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7144 12.7539L34.7859 12.8251L34.7144 12.7539ZM31.3335 12.8488L31.3811 12.8726L31.3335 12.8488Z",
    fill: "#6EB9F8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4287 12.8252L31.5001 12.8964L31.4287 12.8252ZM34.8573 12.8252L34.9287 12.8964L34.8573 12.8252Z",
    fill: "#9DCDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9761 12.8491L35.0236 12.8729L34.9761 12.8491ZM31.0713 12.8966L31.1427 12.9678L31.0713 12.8966Z",
    fill: "#6EB9F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1904 12.9202L31.238 12.944L31.1904 12.9202ZM35.1428 12.8965L35.2142 12.9677L35.1428 12.8965Z",
    fill: "#9DCDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2144 12.8965L35.2859 12.9677L35.2144 12.8965ZM30.9287 12.9677L31.0001 13.0389L30.9287 12.9677Z",
    fill: "#6EB9F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.9678L31.0714 13.039L31 12.9678ZM35.2857 12.9678L35.3571 13.039L35.2857 12.9678Z",
    fill: "#9DCDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3572 12.9678L35.4286 13.039L35.3572 12.9678ZM30.7144 13.039L30.7858 13.1102L30.7144 13.039Z",
    fill: "#6EB9F8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7856 13.0391L30.8571 13.1103L30.7856 13.0391ZM35.4999 13.0391L35.5714 13.1103L35.4999 13.0391Z",
    fill: "#9DCDFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5713 13.0391L35.6427 13.1103L35.5713 13.0391ZM30.5713 13.1103L30.6427 13.1815L30.5713 13.1103Z",
    fill: "#6EB9F8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6431 13.1099L30.7145 13.1811L30.6431 13.1099ZM35.6431 13.1099L35.7145 13.1811L35.6431 13.1099Z",
    fill: "#9DCDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7143 13.1099L35.7857 13.1811L35.7143 13.1099ZM30.4286 13.1811L30.5 13.2523L30.4286 13.1811ZM35.8571 13.1811L35.9286 13.2523L35.8571 13.1811ZM30.2857 13.2523L30.3571 13.3235L30.2857 13.2523ZM36 13.2523L36.0714 13.3235L36 13.2523ZM30.1429 13.3235L30.2143 13.3947L30.1429 13.3235ZM36.1429 13.3235L36.2143 13.3947L36.1429 13.3235ZM30 13.3947L30.0714 13.4659L30 13.3947Z",
    fill: "#6EB9F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0713 13.395L30.1427 13.4662L30.0713 13.395ZM36.2141 13.395L36.2856 13.4662L36.2141 13.395Z",
    fill: "#9DCDFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2856 13.395L36.3571 13.4662L36.2856 13.395Z",
    fill: "#6EB9F8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9287 13.4658L30.0001 13.537L29.9287 13.4658ZM36.3573 13.4658L36.4287 13.537L36.3573 13.4658Z",
    fill: "#9DCDFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7856 13.5371L29.8571 13.6083L29.7856 13.5371ZM36.4999 13.5371L36.5714 13.6083L36.4999 13.5371Z",
    fill: "#6EB9F8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7144 13.6084L29.7858 13.6796L29.7144 13.6084ZM36.5715 13.6084L36.6429 13.6796L36.5715 13.6084Z",
    fill: "#9DCDFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5713 13.6797L29.6427 13.7509L29.5713 13.6797Z",
    fill: "#6EB9F8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6429 13.6797L36.7143 13.7509L36.6429 13.6797ZM29.5 13.7509L29.5714 13.8221L29.5 13.7509ZM36.7143 13.7509L36.7857 13.8221L36.7143 13.7509Z",
    fill: "#9DCDFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3569 13.8218L29.4284 13.893L29.3569 13.8218Z",
    fill: "#6EB9F8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4287 13.8218L29.5001 13.893L29.4287 13.8218Z",
    fill: "#9DCDFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7858 13.8218L36.8572 13.893L36.7858 13.8218ZM29.2858 13.893L29.3572 13.9642L29.2858 13.893ZM29.2144 13.9642L29.2858 14.0354L29.2144 13.9642ZM36.8572 13.9642L36.9286 14.0354L36.8572 13.9642Z",
    fill: "#6EB9F8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1431 14.0356L29.2145 14.1068L29.1431 14.0356Z",
    fill: "#9DCDFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8571 14.0698C40.2499 14.172 39.8701 14.7183 39.9418 15.3169C40.0944 16.5918 40.8009 17.6635 40.7078 19.0192C40.6597 19.7197 40.5298 20.4166 40.3091 21.0839C40.1533 21.5553 39.8791 21.9938 39.9418 22.5079C40.0246 23.1865 40.6418 23.5266 41.2856 23.4174C42.053 23.2874 42.2684 22.348 42.4761 21.7247C43.0913 19.8784 43.0743 17.821 42.5408 15.9577C42.3118 15.1577 41.9348 13.8882 40.8571 14.0698Z",
    fill: "#6EB9F8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0713 14.1069L29.1427 14.1781L29.0713 14.1069Z",
    fill: "#9DCDFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9287 14.1069L37.0001 14.1781L36.9287 14.1069Z",
    fill: "#6EB9F8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.1782L29.0714 14.2494L29 14.1782ZM36.9524 14.2257L36.9762 14.2731L36.9524 14.2257ZM28.9286 14.2494L29 14.3206L28.9286 14.2494ZM28.7143 14.463L28.7857 14.5342L28.7143 14.463ZM28.6429 14.5342L28.7143 14.6054L28.6429 14.5342ZM28.5714 14.6054L28.6429 14.6766L28.5714 14.6054ZM28.5 14.6766L28.5714 14.7478L28.5 14.6766ZM36.9524 14.7241L36.9762 14.7715L36.9524 14.7241Z",
    fill: "#9DCDFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4284 14.7476L28.4998 14.8188L28.4284 14.7476ZM28.3569 14.8188L28.4284 14.89L28.3569 14.8188Z",
    fill: "#6EB9F8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7144 14.8188V14.89H33.0715L32.7144 14.8188Z",
    fill: "#9DCDFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0713 14.8188V14.89H33.357L33.0713 14.8188Z",
    fill: "#6EB9F8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3569 14.8188V14.89H33.7141L33.3569 14.8188Z",
    fill: "#9DCDFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9285 14.8188L36.9999 14.89L36.9285 14.8188ZM28.2856 14.89L28.3571 14.9612L28.2856 14.89Z",
    fill: "#6EB9F8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3335 14.9136L32.3832 14.9385L32.3335 14.9136Z",
    fill: "#9DCDFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4761 14.9138L32.5236 14.9376L32.4761 14.9138ZM33.7856 14.8901V14.9613H33.9999L33.7856 14.8901Z",
    fill: "#6EB9F8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 14.8901L34.0713 14.9613L33.9999 14.8901ZM36.857 14.8901L36.9284 14.9613L36.857 14.8901ZM32.0713 14.9613L32.1427 15.0325L32.0713 14.9613Z",
    fill: "#9DCDFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1431 14.9609L32.2145 15.0321L32.1431 14.9609ZM34.1907 14.9846L34.2383 15.0084L34.1907 14.9846Z",
    fill: "#6EB9F8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2856 14.9609L34.3571 15.0321L34.2856 14.9609Z",
    fill: "#9DCDFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8569 14.9609L36.9284 15.0321L36.8569 14.9609Z",
    fill: "#6EB9F8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2144 15.0322L28.2858 15.1034L28.2144 15.0322ZM31.8572 15.0322L31.9286 15.1034L31.8572 15.0322Z",
    fill: "#9DCDFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9287 15.0322L32.0001 15.1034L31.9287 15.0322ZM34.4287 15.0322L34.5001 15.1034L34.4287 15.0322Z",
    fill: "#6EB9F8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 15.0322L34.5714 15.1034L34.5 15.0322ZM36.7857 15.0322L36.8571 15.1034L36.7857 15.0322Z",
    fill: "#9DCDFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1431 15.1035L28.2145 15.1747L28.1431 15.1035Z",
    fill: "#6EB9F8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6431 15.1035L31.7145 15.1747L31.6431 15.1035Z",
    fill: "#9DCDFF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7141 15.1035L31.7856 15.1747L31.7141 15.1035ZM34.6427 15.1035L34.7141 15.1747L34.6427 15.1035ZM36.7856 15.1035L36.857 15.1747L36.7856 15.1035ZM28.0713 15.1747L28.1427 15.2459L28.0713 15.1747Z",
    fill: "#6EB9F8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 15.1748L31.5714 15.246L31.5 15.1748Z",
    fill: "#9DCDFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5713 15.1748L31.6427 15.246L31.5713 15.1748ZM34.7856 15.1748L34.857 15.246L34.7856 15.1748Z",
    fill: "#6EB9F8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8569 15.1748L34.9284 15.246L34.8569 15.1748Z",
    fill: "#9DCDFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7144 15.1748L36.7858 15.246L36.7144 15.1748Z",
    fill: "#6EB9F8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0713 15.2461L28.1427 15.3173L28.0713 15.2461ZM31.357 15.2461L31.4284 15.3173L31.357 15.2461Z",
    fill: "#9DCDFF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4287 15.2461L31.5001 15.3173L31.4287 15.2461ZM34.9287 15.2461L35.0001 15.3173L34.9287 15.2461Z",
    fill: "#6EB9F8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15.2461L35.0714 15.3173L35 15.2461ZM36.6429 15.2461L36.7143 15.3173L36.6429 15.2461Z",
    fill: "#9DCDFF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.3174L28.0714 15.3886L28 15.3174Z",
    fill: "#6EB9F8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2144 15.3174L31.2858 15.3886L31.2144 15.3174Z",
    fill: "#9DCDFF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2859 15.3174L31.3573 15.3886L31.2859 15.3174ZM35.0716 15.3174L35.143 15.3886L35.0716 15.3174ZM36.5716 15.3174L36.643 15.3886L36.5716 15.3174ZM27.9287 15.3886L28.0001 15.4598L27.9287 15.3886ZM31.143 15.3886L31.2144 15.4598L31.143 15.3886Z",
    fill: "#6EB9F8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2144 15.3882L35.2858 15.4594L35.2144 15.3882ZM36.4286 15.3882L36.5001 15.4594L36.4286 15.3882Z",
    fill: "#9DCDFF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 15.3882L36.5714 15.4594L36.5 15.3882Z",
    fill: "#6EB9F8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9287 15.4595L28.0001 15.5307L27.9287 15.4595ZM31.0001 15.4595L31.0716 15.5307L31.0001 15.4595Z",
    fill: "#9DCDFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2856 15.4595L35.3571 15.5307L35.2856 15.4595Z",
    fill: "#6EB9F8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3569 15.4595L35.4284 15.5307L35.3569 15.4595Z",
    fill: "#9DCDFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3569 15.4595L36.4284 15.5307L36.3569 15.4595ZM27.8569 15.5307L27.9284 15.6019L27.8569 15.5307ZM30.9284 15.5307L30.9998 15.6019L30.9284 15.5307Z",
    fill: "#6EB9F8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5479 15.5545L35.5954 15.5783L35.5479 15.5545ZM36.1431 15.5308L36.2145 15.602L36.1431 15.5308Z",
    fill: "#9DCDFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2144 15.5308L36.2858 15.602L36.2144 15.5308Z",
    fill: "#6EB9F8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7856 15.6021L30.8571 15.6732L30.7856 15.6021Z",
    fill: "#9DCDFF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8335 15.6255L35.8832 15.6505L35.8335 15.6255Z",
    fill: "#6EB9F8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7856 15.6733L27.8571 15.7445L27.7856 15.6733ZM30.7142 15.6733L30.7856 15.7445L30.7142 15.6733Z",
    fill: "#9DCDFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6431 15.7441L30.7145 15.8153L30.6431 15.7441Z",
    fill: "#6EB9F8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7144 15.8154L27.7858 15.8866L27.7144 15.8154Z",
    fill: "#9DCDFF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5716 15.8154L30.6431 15.8866L30.5716 15.8154ZM27.6431 15.8866L27.7145 15.9578L27.6431 15.8866ZM30.5002 15.8866L30.5716 15.9578L30.5002 15.8866Z",
    fill: "#6EB9F8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6431 15.958L27.7145 16.0292L27.6431 15.958Z",
    fill: "#9DCDFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4284 15.958L30.4998 16.0292L30.4284 15.958ZM30.3569 16.0292L30.4284 16.1004L30.3569 16.0292Z",
    fill: "#6EB9F8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5713 16.1001L27.6427 16.1713L27.5713 16.1001Z",
    fill: "#9DCDFF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2857 16.1001L30.3571 16.1713L30.2857 16.1001ZM30.2143 16.1713L30.2857 16.2425L30.2143 16.1713ZM27.5 16.2425L27.5714 16.3137L27.5 16.2425ZM30.1429 16.2425L30.2143 16.3137L30.1429 16.2425Z",
    fill: "#6EB9F8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0713 16.314L30.1427 16.3852L30.0713 16.314Z",
    fill: "#9DCDFF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4287 16.3853L27.5001 16.4565L27.4287 16.3853Z",
    fill: "#6EB9F8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 16.3853L30.0716 16.4565L30.0001 16.3853ZM27.4287 16.4565L27.5001 16.5276L27.4287 16.4565Z",
    fill: "#9DCDFF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 16.4565L30.0712 16.5277L29.9998 16.4565ZM29.9284 16.5277L29.9998 16.5989L29.9284 16.5277ZM27.3569 16.5989L27.4284 16.6701L27.3569 16.5989Z",
    fill: "#6EB9F8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8569 16.5986L29.9284 16.6698L29.8569 16.5986ZM27.3569 16.6698L27.4284 16.741L27.3569 16.6698Z",
    fill: "#9DCDFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8569 16.6699L29.9284 16.7411L29.8569 16.6699Z",
    fill: "#6EB9F8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7856 16.7412L29.8571 16.8124L29.7856 16.7412Z",
    fill: "#9DCDFF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2856 16.8125L27.3571 16.8837L27.2856 16.8125Z",
    fill: "#6EB9F8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2856 16.8833L27.3571 16.9545L27.2856 16.8833Z",
    fill: "#9DCDFF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7144 16.8833L29.7858 16.9545L29.7144 16.8833ZM27.2144 17.0257L27.2858 17.0969L27.2144 17.0257ZM29.6429 17.0257L29.7144 17.0969L29.6429 17.0257Z",
    fill: "#6EB9F8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2144 17.0972L27.2858 17.1684L27.2144 17.0972Z",
    fill: "#9DCDFF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5713 17.1685L29.6427 17.2397L29.5713 17.1685ZM27.1665 17.3583L27.1904 17.4058L27.1665 17.3583Z",
    fill: "#6EB9F8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 17.3105L29.5714 17.3817L29.5 17.3105Z",
    fill: "#9DCDFF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 17.3818L29.5714 17.453L29.5 17.3818Z",
    fill: "#6EB9F8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1431 17.4531L27.2145 17.5243L27.1431 17.4531ZM29.4288 17.5243L29.5002 17.5955L29.4288 17.5243Z",
    fill: "#9DCDFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4287 17.5957L29.5001 17.6669L29.4287 17.5957ZM34.1906 17.6194L34.2382 17.6432L34.1906 17.6194Z",
    fill: "#6EB9F8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2856 17.5957V17.6669H38.3571L37.0714 17.5957H34.2856Z",
    fill: "#9DCDFF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4048 17.6191L38.4524 17.6429L38.4048 17.6191ZM27.0952 17.7141L27.1191 17.7615L27.0952 17.7141ZM33.8571 17.6666L33.9286 17.7378L33.8571 17.6666Z",
    fill: "#6EB9F8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9287 17.6665L34.0001 17.7377L33.9287 17.6665ZM38.5716 17.6665L38.643 17.7377L38.5716 17.6665Z",
    fill: "#9DCDFF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6431 17.6665L38.7145 17.7377L38.6431 17.6665Z",
    fill: "#6EB9F8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3569 17.7378L29.4284 17.809L29.3569 17.7378Z",
    fill: "#9DCDFF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7144 17.7378L33.7858 17.809L33.7144 17.7378Z",
    fill: "#6EB9F8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7856 17.7378L33.8571 17.809L33.7856 17.7378ZM38.7142 17.7378L38.7856 17.809L38.7142 17.7378Z",
    fill: "#9DCDFF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7856 17.7378L38.8571 17.809L38.7856 17.7378Z",
    fill: "#6EB9F8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 17.8091V18.0227H27.1427L27.0713 17.8091Z",
    fill: "#9DCDFF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3809 17.8564L29.4047 17.9039L29.3809 17.8564Z",
    fill: "#6EB9F8"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6428 17.8091L33.7142 17.8803L33.6428 17.8091ZM38.8571 17.8091L38.9285 17.8803L38.8571 17.8091ZM33.5714 17.8803L33.6428 17.9515L33.5714 17.8803ZM38.9285 17.8803L38.9999 17.9515L38.9285 17.8803ZM33.4999 17.9515L33.5714 18.0227L33.4999 17.9515ZM38.9999 17.9515L39.0714 18.0227L38.9999 17.9515ZM33.4285 18.0227L33.4999 18.0939L33.4285 18.0227ZM39.0714 18.0227L39.1428 18.0939L39.0714 18.0227ZM29.2856 18.0939L29.3571 18.1651L29.2856 18.0939ZM33.3571 18.0939L33.4285 18.1651L33.3571 18.0939Z",
    fill: "#9DCDFF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1429 18.0938L39.2143 18.1649L39.1429 18.0938ZM27 18.1649V18.6633H27.0714L27 18.1649ZM29.2857 18.1649V18.4497H29.3571L29.2857 18.1649ZM33.2857 18.1649L33.3571 18.2361L33.2857 18.1649Z",
    fill: "#6EB9F8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2856 18.2363L33.3571 18.3075L33.2856 18.2363ZM39.2142 18.2363L39.2856 18.3075L39.2142 18.2363Z",
    fill: "#9DCDFF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2144 18.3784L33.2858 18.4496L33.2144 18.3784ZM39.2858 18.3784L39.3572 18.4496L39.2858 18.3784Z",
    fill: "#6EB9F8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2144 18.4497L33.2859 18.5209L33.2144 18.4497ZM39.2859 18.4497L39.3573 18.5209L39.2859 18.4497ZM27.0239 18.7108L27.0478 18.7582L27.0239 18.7108Z",
    fill: "#9DCDFF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1666 18.7109L33.1905 18.7584L33.1666 18.7109ZM27 18.8058V19.3042H27.0714L27 18.8058ZM29.2857 19.0194V19.3042H29.3571L29.2857 19.0194Z",
    fill: "#6EB9F8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2144 19.0195L33.2858 19.0907L33.2144 19.0195Z",
    fill: "#9DCDFF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2144 19.0908L33.2858 19.162L33.2144 19.0908ZM33.2858 19.2332L33.3572 19.3044L33.2858 19.2332Z",
    fill: "#6EB9F8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2858 19.2329V19.4465H39.3572L39.2858 19.2329ZM29.3096 19.3516L29.3334 19.399L29.3096 19.3516Z",
    fill: "#9DCDFF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3569 19.3755L33.4284 19.4467L33.3569 19.3755ZM33.4284 19.4467L33.4998 19.5179L33.4284 19.4467ZM39.2855 19.4467V19.6603H39.3569L39.2855 19.4467Z",
    fill: "#6EB9F8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0952 19.5654L27.1191 19.6128L27.0952 19.5654Z",
    fill: "#9DCDFF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3809 19.5654L29.4047 19.6128L29.3809 19.5654Z",
    fill: "#6EB9F8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 19.5176L33.5714 19.5888L33.5 19.5176Z",
    fill: "#9DCDFF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5713 19.5889L33.6427 19.6601L33.5713 19.5889ZM27.0713 19.6601V19.8737H27.1427L27.0713 19.6601Z",
    fill: "#6EB9F8"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3569 19.6602L29.4284 19.7314L29.3569 19.6602Z",
    fill: "#9DCDFF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6431 19.6602L33.7145 19.7314L33.6431 19.6602Z",
    fill: "#6EB9F8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7144 19.6602L33.7858 19.7314L33.7144 19.6602Z",
    fill: "#9DCDFF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7856 19.7314L33.8571 19.8026L33.7856 19.7314Z",
    fill: "#6EB9F8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8569 19.7314L33.9284 19.8026L33.8569 19.7314Z",
    fill: "#9DCDFF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4521 19.8502L29.476 19.8976L29.4521 19.8502ZM33.9284 19.8027L33.9998 19.8739L33.9284 19.8027Z",
    fill: "#6EB9F8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0479 19.8262L34.0954 19.85L34.0479 19.8262ZM39.2383 19.85L39.2621 19.8974L39.2383 19.85Z",
    fill: "#9DCDFF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4761 19.8975L34.5236 19.9212L34.4761 19.8975ZM36.8808 19.9212L36.9046 19.9687L36.8808 19.9212Z",
    fill: "#6EB9F8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1665 19.9923L27.1904 20.0397L27.1665 19.9923ZM29.4284 19.9448L29.4999 20.016L29.4284 19.9448Z",
    fill: "#9DCDFF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2143 19.9448L39.2857 20.016L39.2143 19.9448ZM29.5 20.016L29.5714 20.0872L29.5 20.016Z",
    fill: "#6EB9F8"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8569 20.0161L36.9284 20.0873L36.8569 20.0161Z",
    fill: "#9DCDFF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1431 20.0874L27.2145 20.1586L27.1431 20.0874Z",
    fill: "#6EB9F8"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 20.0874L29.5714 20.1586L29.5 20.0874Z",
    fill: "#9DCDFF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7856 20.1587L36.8571 20.2299L36.7856 20.1587Z",
    fill: "#6EB9F8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1431 20.1587L39.2145 20.2299L39.1431 20.1587Z",
    fill: "#9DCDFF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5713 20.23L29.6427 20.3012L29.5713 20.23Z",
    fill: "#6EB9F8"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7856 20.23L36.8571 20.3012L36.7856 20.23Z",
    fill: "#9DCDFF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1665 20.2773L39.1904 20.3248L39.1665 20.2773Z",
    fill: "#6EB9F8"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2144 20.3008L27.2858 20.372L27.2144 20.3008ZM29.5715 20.3008L29.6429 20.372L29.5715 20.3008Z",
    fill: "#9DCDFF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7144 20.3008L36.7858 20.372L36.7144 20.3008ZM27.2144 20.372L27.2858 20.4432L27.2144 20.372ZM29.6429 20.372L29.7144 20.4432L29.6429 20.372Z",
    fill: "#6EB9F8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7145 20.3721L36.7859 20.4433L36.7145 20.3721ZM39.0954 20.4196L39.1193 20.467L39.0954 20.4196ZM29.6431 20.4433L29.7145 20.5145L29.6431 20.4433Z",
    fill: "#9DCDFF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6431 20.4434L36.7145 20.5146L36.6431 20.4434Z",
    fill: "#6EB9F8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2856 20.5146L27.3571 20.5858L27.2856 20.5146Z",
    fill: "#9DCDFF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7144 20.5146L29.7858 20.5858L29.7144 20.5146Z",
    fill: "#6EB9F8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6431 20.5146L36.7145 20.5858L36.6431 20.5146Z",
    fill: "#9DCDFF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0714 20.5146L39.1428 20.5858L39.0714 20.5146ZM27.2856 20.5858L27.3571 20.657L27.2856 20.5858Z",
    fill: "#6EB9F8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7144 20.5859L29.7858 20.6571L29.7144 20.5859Z",
    fill: "#9DCDFF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5714 20.5859L36.6428 20.6571L36.5714 20.5859ZM29.7856 20.6571L29.8571 20.7283L29.7856 20.6571Z",
    fill: "#6EB9F8"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5712 20.6567L36.6426 20.7279L36.5712 20.6567ZM38.9998 20.6567L39.0712 20.7279L38.9998 20.6567ZM27.3569 20.7279L27.4284 20.7991L27.3569 20.7279Z",
    fill: "#9DCDFF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4998 20.728L36.5712 20.7992L36.4998 20.728ZM38.9998 20.728L39.0712 20.7992L38.9998 20.728ZM27.3569 20.7992L27.4284 20.8704L27.3569 20.7992Z",
    fill: "#6EB9F8"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8569 20.7993L29.9284 20.8705L29.8569 20.7993Z",
    fill: "#9DCDFF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9287 20.8706L30.0001 20.9418L29.9287 20.8706Z",
    fill: "#6EB9F8"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4287 20.8706L36.5001 20.9418L36.4287 20.8706ZM38.9287 20.8706L39.0001 20.9418L38.9287 20.8706ZM27.4287 20.9418L27.5001 21.013L27.4287 20.9418ZM29.9287 20.9418L30.0001 21.013L29.9287 20.9418Z",
    fill: "#9DCDFF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3573 20.9419L36.4287 21.0131L36.3573 20.9419ZM38.9287 20.9419L39.0001 21.0131L38.9287 20.9419ZM27.4287 21.0131L27.5001 21.0843L27.4287 21.0131Z",
    fill: "#6EB9F8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21.0132L30.0714 21.0844L30 21.0132ZM38.8571 21.0132L38.9286 21.0844L38.8571 21.0132ZM27.5 21.0844L27.5714 21.1556L27.5 21.0844Z",
    fill: "#9DCDFF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0713 21.084L30.1427 21.1552L30.0713 21.084Z",
    fill: "#6EB9F8"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2856 21.084L36.3571 21.1552L36.2856 21.084Z",
    fill: "#9DCDFF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8571 21.084L38.9286 21.1552L38.8571 21.084ZM27.5 21.1552L27.5714 21.2264L27.5 21.1552ZM30.1429 21.1552L30.2143 21.2264L30.1429 21.1552Z",
    fill: "#6EB9F8"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2144 21.1553L36.2858 21.2265L36.2144 21.1553Z",
    fill: "#9DCDFF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1431 21.2266L36.2145 21.2978L36.1431 21.2266ZM38.7859 21.2266L38.8574 21.2978L38.7859 21.2266Z",
    fill: "#6EB9F8"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5713 21.2979L27.6427 21.369L27.5713 21.2979ZM30.2141 21.2979L30.2856 21.369L30.2141 21.2979Z",
    fill: "#9DCDFF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0713 21.2979L36.1427 21.369L36.0713 21.2979Z",
    fill: "#6EB9F8"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2856 21.3691L30.3571 21.4403L30.2856 21.3691Z",
    fill: "#9DCDFF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21.3691L36.0714 21.4403L36 21.3691Z",
    fill: "#6EB9F8"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7145 21.3691L38.7859 21.4403L38.7145 21.3691ZM27.6431 21.4403L27.7145 21.5115L27.6431 21.4403ZM30.3574 21.4403L30.4288 21.5115L30.3574 21.4403Z",
    fill: "#9DCDFF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9287 21.4399L36.0001 21.5111L35.9287 21.4399Z",
    fill: "#6EB9F8"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4287 21.5112L30.5001 21.5824L30.4287 21.5112Z",
    fill: "#9DCDFF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8569 21.5112L35.9284 21.5824L35.8569 21.5112Z",
    fill: "#6EB9F8"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6431 21.5112L38.7145 21.5824L38.6431 21.5112Z",
    fill: "#9DCDFF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7144 21.5825L27.7858 21.6537L27.7144 21.5825Z",
    fill: "#6EB9F8"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 21.5825L30.5714 21.6537L30.5 21.5825Z",
    fill: "#9DCDFF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7856 21.5825L35.8571 21.6537L35.7856 21.5825Z",
    fill: "#6EB9F8"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5713 21.6538L30.6427 21.725L30.5713 21.6538Z",
    fill: "#9DCDFF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7144 21.6538L35.7858 21.725L35.7144 21.6538Z",
    fill: "#6EB9F8"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5713 21.6538L38.6427 21.725L38.5713 21.6538Z",
    fill: "#9DCDFF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7856 21.7251L27.8571 21.7963L27.7856 21.7251ZM30.7142 21.7251L30.7856 21.7963L30.7142 21.7251ZM35.6428 21.7251L35.7142 21.7963L35.6428 21.7251Z",
    fill: "#6EB9F8"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8569 21.7959L27.9284 21.8671L27.8569 21.7959Z",
    fill: "#9DCDFF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7856 21.7959L30.8571 21.8671L30.7856 21.7959Z",
    fill: "#6EB9F8"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5713 21.7959L35.6427 21.8671L35.5713 21.7959Z",
    fill: "#9DCDFF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4998 21.7959L38.5712 21.8671L38.4998 21.7959ZM27.8569 21.8671L27.9284 21.9383L27.8569 21.8671Z",
    fill: "#6EB9F8"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8569 21.8672L30.9284 21.9384L30.8569 21.8672Z",
    fill: "#9DCDFF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4287 21.8672L35.5001 21.9384L35.4287 21.8672Z",
    fill: "#6EB9F8"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5001 21.8672L35.5716 21.9384L35.5001 21.8672ZM38.4287 21.8672L38.5001 21.9384L38.4287 21.8672ZM27.9287 21.9384L28.0001 22.0096L27.9287 21.9384ZM30.9287 21.9384L31.0001 22.0096L30.9287 21.9384Z",
    fill: "#9DCDFF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21.9385L31.0714 22.0097L31 21.9385ZM35.3571 21.9385L35.4286 22.0097L35.3571 21.9385ZM38.4286 21.9385L38.5 22.0097L38.4286 21.9385Z",
    fill: "#6EB9F8"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0713 22.0098L31.1427 22.081L31.0713 22.0098Z",
    fill: "#9DCDFF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2144 22.0098L35.2858 22.081L35.2144 22.0098Z",
    fill: "#6EB9F8"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2856 22.0098L35.3571 22.081L35.2856 22.0098ZM38.3571 22.0098L38.4285 22.081L38.3571 22.0098Z",
    fill: "#9DCDFF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22.0811L28.0714 22.1523L28 22.0811ZM31.2143 22.0811L31.2857 22.1523L31.2143 22.0811Z",
    fill: "#6EB9F8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1427 22.0811L35.2141 22.1523L35.1427 22.0811ZM28.0713 22.1523L28.1427 22.2234L28.0713 22.1523ZM31.2856 22.1523L31.357 22.2234L31.2856 22.1523Z",
    fill: "#9DCDFF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3569 22.1523L31.4284 22.2235L31.3569 22.1523ZM34.9998 22.1523L35.0712 22.2235L34.9998 22.1523ZM38.2855 22.1523L38.3569 22.2235L38.2855 22.1523Z",
    fill: "#6EB9F8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4287 22.2231L31.5001 22.2943L31.4287 22.2231Z",
    fill: "#9DCDFF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 22.2231L31.5714 22.2943L31.5 22.2231ZM34.8571 22.2231L34.9286 22.2943L34.8571 22.2231Z",
    fill: "#6EB9F8"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2144 22.2231L38.2858 22.2943L38.2144 22.2231Z",
    fill: "#9DCDFF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1431 22.2944L28.2145 22.3656L28.1431 22.2944Z",
    fill: "#6EB9F8"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5713 22.2944L31.6427 22.3656L31.5713 22.2944Z",
    fill: "#9DCDFF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6431 22.2944L31.7145 22.3656L31.6431 22.2944Z",
    fill: "#6EB9F8"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7144 22.2944L34.7858 22.3656L34.7144 22.2944ZM38.1429 22.2944L38.2144 22.3656L38.1429 22.2944ZM28.2144 22.3656L28.2858 22.4368L28.2144 22.3656ZM31.7858 22.3656L31.8572 22.4368L31.7858 22.3656Z",
    fill: "#9DCDFF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8569 22.3657L31.9284 22.4369L31.8569 22.3657ZM34.4998 22.3657L34.5712 22.4369L34.4998 22.3657Z",
    fill: "#6EB9F8"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5713 22.3657L34.6427 22.4369L34.5713 22.3657Z",
    fill: "#9DCDFF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1431 22.3657L38.2145 22.4369L38.1431 22.3657Z",
    fill: "#6EB9F8"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2856 22.437L28.3571 22.5082L28.2856 22.437ZM31.9285 22.437L31.9999 22.5082L31.9285 22.437Z",
    fill: "#9DCDFF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0479 22.4607L32.0954 22.4845L32.0479 22.4607ZM34.2859 22.437L34.3574 22.5082L34.2859 22.437Z",
    fill: "#6EB9F8"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3569 22.437L34.4284 22.5082L34.3569 22.437Z",
    fill: "#9DCDFF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0713 22.437L38.1427 22.5082L38.0713 22.437Z",
    fill: "#6EB9F8"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2144 22.5083L32.2858 22.5795L32.2144 22.5083Z",
    fill: "#9DCDFF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3335 22.532L32.3811 22.5558L32.3335 22.532ZM34.0001 22.5083L34.0716 22.5795L34.0001 22.5083Z",
    fill: "#6EB9F8"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1191 22.532L34.1667 22.5558L34.1191 22.532ZM38.0001 22.5083L38.0715 22.5795L38.0001 22.5083Z",
    fill: "#9DCDFF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3569 22.5791L28.4284 22.6503L28.3569 22.5791Z",
    fill: "#6EB9F8"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22.5791V22.6503H32.7143L32.5 22.5791Z",
    fill: "#9DCDFF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7144 22.5791V22.6503H33.0001L32.7144 22.5791ZM33.3572 22.5791V22.6503H33.7144L33.3572 22.5791Z",
    fill: "#6EB9F8"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7617 22.6028L33.8093 22.6266L33.7617 22.6028ZM37.9284 22.5791L37.9998 22.6503L37.9284 22.5791Z",
    fill: "#9DCDFF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4287 22.6504L28.5001 22.7216L28.4287 22.6504Z",
    fill: "#6EB9F8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 22.7217L28.5714 22.7929L28.5 22.7217Z",
    fill: "#9DCDFF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8569 22.7217L37.9284 22.7929L37.8569 22.7217Z",
    fill: "#6EB9F8"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5713 22.793L28.6427 22.8642L28.5713 22.793Z",
    fill: "#9DCDFF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7856 22.793L37.8571 22.8642L37.7856 22.793Z",
    fill: "#6EB9F8"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6431 22.8643L28.7145 22.9355L28.6431 22.8643Z",
    fill: "#9DCDFF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7144 22.8643L37.7858 22.9355L37.7144 22.8643Z",
    fill: "#6EB9F8"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7144 22.9351L28.7858 23.0063L28.7144 22.9351Z",
    fill: "#9DCDFF"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6431 22.9351L37.7145 23.0063L37.6431 22.9351Z",
    fill: "#6EB9F8"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7856 23.0063L28.8571 23.0775L28.7856 23.0063Z",
    fill: "#9DCDFF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5713 23.0063L37.6427 23.0775L37.5713 23.0063Z",
    fill: "#6EB9F8"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8569 23.0776L28.9284 23.1488L28.8569 23.0776Z",
    fill: "#9DCDFF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 23.0776L37.5714 23.1488L37.5 23.0776Z",
    fill: "#6EB9F8"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9287 23.1489L29.0001 23.2201L28.9287 23.1489Z",
    fill: "#9DCDFF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4287 23.1489L37.5001 23.2201L37.4287 23.1489Z",
    fill: "#6EB9F8"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23.2202L29.0714 23.2914L29 23.2202Z",
    fill: "#9DCDFF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3569 23.2202L37.4284 23.2914L37.3569 23.2202Z",
    fill: "#6EB9F8"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0713 23.2915L29.1427 23.3627L29.0713 23.2915Z",
    fill: "#9DCDFF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2856 23.2915L37.3571 23.3627L37.2856 23.2915Z",
    fill: "#6EB9F8"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1431 23.3623L29.2145 23.4335L29.1431 23.3623Z",
    fill: "#9DCDFF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2144 23.3623L37.2858 23.4335L37.2144 23.3623ZM29.2144 23.4335L29.2858 23.5047L29.2144 23.4335Z",
    fill: "#6EB9F8"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0713 23.4336L37.1427 23.5048L37.0713 23.4336Z",
    fill: "#9DCDFF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1428 23.4336L37.2142 23.5048L37.1428 23.4336ZM29.2856 23.5048L29.3571 23.576L29.2856 23.5048Z",
    fill: "#6EB9F8"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0001 23.5049L37.0716 23.5761L37.0001 23.5049ZM29.4287 23.5761L29.5001 23.6473L29.4287 23.5761Z",
    fill: "#9DCDFF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9287 23.5762L37.0001 23.6474L36.9287 23.5762Z",
    fill: "#6EB9F8"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 23.6475L29.5714 23.7187L29.5 23.6475Z",
    fill: "#9DCDFF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M36.857 23.6475L36.9284 23.7187L36.857 23.6475ZM29.5713 23.7187L29.6427 23.7899L29.5713 23.7187Z",
    fill: "#6EB9F8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7144 23.7183L36.7858 23.7895L36.7144 23.7183ZM29.7144 23.7895L29.7858 23.8607L29.7144 23.7895Z",
    fill: "#9DCDFF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6428 23.7896L36.7142 23.8607L36.6428 23.7896ZM29.7856 23.8607L29.8571 23.9319L29.7856 23.8607Z",
    fill: "#6EB9F8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 23.8608L36.5714 23.932L36.5 23.8608Z",
    fill: "#9DCDFF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5713 23.8608L36.6427 23.932L36.5713 23.8608Z",
    fill: "#6EB9F8"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9287 23.9321L30.0001 24.0033L29.9287 23.9321Z",
    fill: "#9DCDFF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4286 23.9321L36.5 24.0033L36.4286 23.9321ZM30 24.0033L30.0714 24.0745L30 24.0033Z",
    fill: "#6EB9F8"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0713 24.0034L30.1427 24.0746L30.0713 24.0034ZM36.2856 24.0034L36.357 24.0746L36.2856 24.0034Z",
    fill: "#9DCDFF"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1431 24.0742L30.2145 24.1454L30.1431 24.0742Z",
    fill: "#6EB9F8"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1431 24.0742L36.2145 24.1454L36.1431 24.0742Z",
    fill: "#9DCDFF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2144 24.0742L36.2858 24.1454L36.2144 24.0742Z",
    fill: "#6EB9F8"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2856 24.1455L30.3571 24.2167L30.2856 24.1455ZM35.9999 24.1455L36.0714 24.2167L35.9999 24.1455Z",
    fill: "#9DCDFF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0713 24.1455L36.1427 24.2167L36.0713 24.1455Z",
    fill: "#6EB9F8"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4287 24.2168L30.5001 24.288L30.4287 24.2168ZM35.8573 24.2168L35.9287 24.288L35.8573 24.2168Z",
    fill: "#9DCDFF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9284 24.2168L35.9999 24.288L35.9284 24.2168ZM30.5713 24.288L30.6427 24.3592L30.5713 24.288Z",
    fill: "#6EB9F8"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7144 24.2881L35.7858 24.3593L35.7144 24.2881Z",
    fill: "#9DCDFF"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7858 24.2881L35.8572 24.3593L35.7858 24.2881ZM30.7144 24.3593L30.7858 24.4305L30.7144 24.3593Z",
    fill: "#6EB9F8"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7856 24.3594L30.8571 24.4306L30.7856 24.3594ZM35.5714 24.3594L35.6428 24.4306L35.5714 24.3594Z",
    fill: "#9DCDFF"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6426 24.3594L35.7141 24.4306L35.6426 24.3594ZM30.8569 24.4306L30.9284 24.5018L30.8569 24.4306Z",
    fill: "#6EB9F8"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9287 24.4307L31.0001 24.5019L30.9287 24.4307ZM35.3573 24.4307L35.4287 24.5019L35.3573 24.4307Z",
    fill: "#9DCDFF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4284 24.4307L35.4999 24.5019L35.4284 24.4307ZM31.0713 24.5019L31.1427 24.5731L31.0713 24.5019Z",
    fill: "#6EB9F8"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1431 24.5015L31.2145 24.5727L31.1431 24.5015ZM35.2145 24.5015L35.2859 24.5727L35.2145 24.5015Z",
    fill: "#9DCDFF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2856 24.5015L35.3571 24.5727L35.2856 24.5015ZM31.2856 24.5727L31.3571 24.6439L31.2856 24.5727Z",
    fill: "#6EB9F8"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3569 24.5728L31.4284 24.644L31.3569 24.5728ZM34.9998 24.5728L35.0712 24.644L34.9998 24.5728Z",
    fill: "#9DCDFF"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0714 24.5728L35.1429 24.644L35.0714 24.5728ZM31.5 24.644L31.5714 24.7151L31.5 24.644Z",
    fill: "#6EB9F8"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6191 24.6678L31.6667 24.6915L31.6191 24.6678ZM34.7144 24.644L34.7858 24.7152L34.7144 24.644Z",
    fill: "#9DCDFF"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 24.6675L34.8809 24.6913L34.8333 24.6675ZM31.7856 24.715L31.8571 24.7862L31.7856 24.715Z",
    fill: "#6EB9F8"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9048 24.739L31.9524 24.7628L31.9048 24.739ZM34.4286 24.7153L34.5 24.7865L34.4286 24.7153Z",
    fill: "#9DCDFF"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5475 24.7388L34.5951 24.7625L34.5475 24.7388ZM32.0713 24.7863V24.8575H32.2856L32.0713 24.7863Z",
    fill: "#6EB9F8"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3335 24.8103L32.3811 24.8341L32.3335 24.8103ZM33.9287 24.7866V24.8578H34.143L33.9287 24.7866Z",
    fill: "#9DCDFF"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1904 24.8101L34.2379 24.8338L34.1904 24.8101ZM32.5713 24.8575V24.9287H32.9999L32.5713 24.8575Z",
    fill: "#6EB9F8"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24.8574V24.9286H33.4286L33 24.8574Z",
    fill: "#9DCDFF"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4287 24.8574V24.9286H33.7859L33.4287 24.8574ZM48.0001 32.1196L47.8573 32.3332L48.0001 32.1196Z",
    fill: "#6EB9F8"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0713 32.1196V32.1908H49.1427L48.0713 32.1196Z",
    fill: "#9DCDFF"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1431 32.1196L49.2145 32.1908L49.1431 32.1196Z",
    fill: "#6EB9F8"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3573 34.9674C49.3573 34.2679 49.5949 33.0558 49.3142 32.4148C49.1586 32.0599 48.0693 32.0646 47.9103 32.4148C47.6797 32.9229 47.8573 33.8447 47.8573 34.3978V38.6697C47.8573 39.1864 47.6946 40.0349 47.9103 40.5103C48.0572 40.8339 48.7059 40.7713 48.9988 40.7239C49.5466 40.6351 49.3573 39.7141 49.3573 39.3105C49.3573 38.0707 49.0331 35.0041 51.2144 35.5625C53.1896 36.0681 52.0096 39.1011 52.38 40.4454C52.4843 40.8243 53.4203 40.8705 53.6713 40.6203C54.0241 40.2686 53.7858 38.8654 53.7858 38.3849C53.7858 37.5238 53.914 36.5565 53.5492 35.7506C52.8013 34.0986 50.6856 33.958 49.3573 34.9674Z",
    fill: "#FEFEFF"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2141 32.1909L49.2855 32.2621L49.2141 32.1909ZM49.2855 32.2621L49.3569 32.3333L49.2855 32.2621ZM47.8569 32.3333L47.9284 32.4045L47.8569 32.3333Z",
    fill: "#9DCDFF"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3571 32.4043C49.3571 32.9386 49.0952 34.5437 49.4999 34.8962L49.3571 32.4043ZM19.7856 32.4755V32.5467H19.9999L19.7856 32.4755Z",
    fill: "#6EB9F8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.4756V32.5468H20.7857L20 32.4756Z",
    fill: "#9DCDFF"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7856 32.4756V32.5468H20.9999L20.7856 32.4756ZM28.9999 32.4756V32.5468H29.2142L28.9999 32.4756Z",
    fill: "#6EB9F8"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2144 32.4756V32.5468H30.0001L29.2144 32.4756Z",
    fill: "#9DCDFF"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M30 32.4756V32.5468H30.2143L30 32.4756ZM19.4048 32.5705L19.4524 32.5943L19.4048 32.5705Z",
    fill: "#6EB9F8"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5479 32.5708L19.5975 32.5958L19.5479 32.5708Z",
    fill: "#9DCDFF"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0715 37.3886C22.3555 39.8495 18.678 40.1802 17.8117 37.6022C17.1387 35.5995 18.8515 33.6486 20.9286 33.9943C21.6931 34.1215 22.0115 34.735 22.6493 35.0098C23.0152 35.1675 23.7773 34.7485 23.7552 34.3268C23.7175 33.605 22.5147 32.9893 21.9286 32.7853C19.9667 32.1022 17.6738 32.8067 16.666 34.6831C14.4464 38.8156 20.0075 42.8795 23.3569 39.664C24.0419 39.0064 24.4551 38.0542 24.4972 37.1038C24.5112 36.7891 24.5611 36.363 24.2752 36.1499C24.0472 35.9801 23.6957 36.0358 23.4286 36.0358H21.3572C21.0811 36.0358 20.6252 35.9591 20.4816 36.2656C19.7747 37.774 22.3034 37.3886 23.0715 37.3886Z",
    fill: "#FEFEFF"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1904 32.5708L21.2401 32.5958L21.1904 32.5708Z",
    fill: "#9DCDFF"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 32.5708L21.3811 32.5946L21.3335 32.5708ZM28.6192 32.5708L28.6668 32.5946L28.6192 32.5708Z",
    fill: "#6EB9F8"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7617 32.5708L28.8114 32.5958L28.7617 32.5708Z",
    fill: "#9DCDFF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8569 32.578C25.0428 33.1764 24.1786 38.65 27.6426 40.3805C28.2449 40.6814 28.9028 40.8054 29.5712 40.8057C30.1676 40.8059 30.7336 40.7448 31.2855 40.4987C31.7239 40.3031 33.5134 39.2939 32.8341 38.6629C31.8792 37.7759 31.4991 38.8566 30.6426 39.2055C29.4522 39.6904 28.0182 39.2442 27.3247 38.1714C26.0218 36.156 27.832 33.6093 30.1426 33.9939C31.1187 34.1563 31.6146 35.4276 32.5708 34.8532C33.3536 34.383 32.6776 33.7315 32.1426 33.3413C31.1978 32.6519 30.0132 32.3966 28.8569 32.578Z",
    fill: "#FEFEFF"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4048 32.5708L30.4545 32.5958L30.4048 32.5708Z",
    fill: "#9DCDFF"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5479 32.5708L30.5954 32.5946L30.5479 32.5708ZM19.1431 32.6183L19.2145 32.6895L19.1431 32.6183Z",
    fill: "#6EB9F8"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2144 32.6182L19.2858 32.6894L19.2144 32.6182ZM21.5001 32.6182L21.5715 32.6894L21.5001 32.6182Z",
    fill: "#9DCDFF"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5713 32.6182L21.6427 32.6894L21.5713 32.6182ZM28.357 32.6182L28.4284 32.6894L28.357 32.6182Z",
    fill: "#6EB9F8"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4287 32.6182L28.5001 32.6894L28.4287 32.6182ZM30.7144 32.6182L30.7859 32.6894L30.7144 32.6182Z",
    fill: "#9DCDFF"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7857 32.6182L30.8571 32.6894L30.7857 32.6182ZM18.9048 32.7131L18.9524 32.7368L18.9048 32.7131Z",
    fill: "#6EB9F8"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M19 32.6895L19.0714 32.7606L19 32.6895ZM21.7143 32.6895L21.7857 32.7606L21.7143 32.6895Z",
    fill: "#9DCDFF"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8335 32.7129L21.8811 32.7367L21.8335 32.7129ZM28.1192 32.7129L28.1668 32.7367L28.1192 32.7129Z",
    fill: "#6EB9F8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2144 32.6895L28.2858 32.7606L28.2144 32.6895ZM30.9286 32.6895L31.0001 32.7606L30.9286 32.6895Z",
    fill: "#9DCDFF"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 32.6895L31.0715 32.7606L31.0001 32.6895ZM18.7144 32.7606L18.7858 32.8318L18.7144 32.7606Z",
    fill: "#6EB9F8"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7856 32.7607L18.8571 32.8319L18.7856 32.7607ZM21.9285 32.7607L21.9999 32.8319L21.9285 32.7607Z",
    fill: "#9DCDFF"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32.7607L22.0714 32.8319L22 32.7607ZM27.9286 32.7607L28 32.8319L27.9286 32.7607Z",
    fill: "#6EB9F8"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32.7607L28.0714 32.8319L28 32.7607ZM31.1429 32.7607L31.2143 32.8319L31.1429 32.7607Z",
    fill: "#9DCDFF"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2141 32.7607L31.2856 32.8319L31.2141 32.7607ZM18.5713 32.8319L18.6427 32.9031L18.5713 32.8319ZM22.1427 32.8319L22.2141 32.9031L22.1427 32.8319ZM27.7856 32.8319L27.857 32.9031L27.7856 32.8319Z",
    fill: "#6EB9F8"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2856 32.8315L31.3571 32.9027L31.2856 32.8315Z",
    fill: "#9DCDFF"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3569 32.8315L31.4284 32.9027L31.3569 32.8315Z",
    fill: "#6EB9F8"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4287 32.9028L18.5001 32.974L18.4287 32.9028ZM22.2859 32.9028L22.3573 32.974L22.2859 32.9028ZM27.643 32.9028L27.7144 32.974L27.643 32.9028Z",
    fill: "#9DCDFF"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 32.9028L31.5714 32.974L31.5 32.9028Z",
    fill: "#6EB9F8"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2856 32.9741L18.3571 33.0453L18.2856 32.9741Z",
    fill: "#9DCDFF"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4287 32.9741L22.5001 33.0453L22.4287 32.9741Z",
    fill: "#6EB9F8"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 32.9741L27.5714 33.0453L27.5 32.9741ZM31.5714 32.9741L31.6429 33.0453L31.5714 32.9741Z",
    fill: "#9DCDFF"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6431 32.9741L31.7145 33.0453L31.6431 32.9741ZM18.1431 33.0453L18.2145 33.1165L18.1431 33.0453ZM22.5716 33.0453L22.6431 33.1165L22.5716 33.0453ZM27.3574 33.0453L27.4288 33.1165L27.3574 33.0453Z",
    fill: "#6EB9F8"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7144 33.0454L31.7858 33.1166L31.7144 33.0454Z",
    fill: "#9DCDFF"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7856 33.0454L31.8571 33.1166L31.7856 33.0454Z",
    fill: "#6EB9F8"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0713 33.1167L18.1427 33.1879L18.0713 33.1167ZM22.6427 33.1167L22.7141 33.1879L22.6427 33.1167ZM27.2856 33.1167L27.357 33.1879L27.2856 33.1167ZM31.857 33.1167L31.9284 33.1879L31.857 33.1167Z",
    fill: "#9DCDFF"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9287 33.1875L18.0001 33.2587L17.9287 33.1875ZM22.7859 33.1875L22.8573 33.2587L22.7859 33.1875ZM27.143 33.1875L27.2144 33.2587L27.143 33.1875Z",
    fill: "#6EB9F8"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9287 33.1875L32.0001 33.2587L31.9287 33.1875Z",
    fill: "#9DCDFF"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M32 33.1875L32.0714 33.2587L32 33.1875Z",
    fill: "#6EB9F8"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8569 33.2588L17.9284 33.33L17.8569 33.2588ZM22.8569 33.2588L22.9284 33.33L22.8569 33.2588ZM27.0712 33.2588L27.1427 33.33L27.0712 33.2588Z",
    fill: "#9DCDFF"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0715 33.2588L32.1429 33.33L32.0715 33.2588ZM17.7144 33.33L17.7858 33.4012L17.7144 33.33ZM23.0001 33.33L23.0715 33.4012L23.0001 33.33ZM26.9286 33.33L27.0001 33.4012L26.9286 33.33Z",
    fill: "#6EB9F8"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1431 33.3301L32.2145 33.4013L32.1431 33.3301Z",
    fill: "#9DCDFF"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6431 33.4014L17.7145 33.4726L17.6431 33.4014ZM23.0716 33.4014L23.1431 33.4726L23.0716 33.4014ZM26.8574 33.4014L26.9288 33.4726L26.8574 33.4014Z",
    fill: "#6EB9F8"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2144 33.4014L32.2858 33.4726L32.2144 33.4014Z",
    fill: "#9DCDFF"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5713 33.4727L17.6427 33.5439L17.5713 33.4727ZM23.1427 33.4727L23.2141 33.5439L23.1427 33.4727ZM26.7856 33.4727L26.857 33.5439L26.7856 33.4727ZM32.357 33.4727L32.4284 33.5439L32.357 33.4727Z",
    fill: "#6EB9F8"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33.5435L17.5714 33.6147L17.5 33.5435ZM23.2143 33.5435L23.2857 33.6147L23.2143 33.5435ZM26.7143 33.5435L26.7857 33.6147L26.7143 33.5435Z",
    fill: "#9DCDFF"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4287 33.5435L32.5001 33.6147L32.4287 33.5435Z",
    fill: "#6EB9F8"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4287 33.6147L17.5001 33.6859L17.4287 33.6147ZM23.2859 33.6147L23.3573 33.6859L23.2859 33.6147ZM26.643 33.6147L26.7144 33.6859L26.643 33.6147Z",
    fill: "#9DCDFF"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 33.6147L32.5714 33.6859L32.5 33.6147Z",
    fill: "#6EB9F8"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3569 33.686L17.4284 33.7572L17.3569 33.686ZM23.3569 33.686L23.4284 33.7572L23.3569 33.686ZM26.5712 33.686L26.6426 33.7572L26.5712 33.686Z",
    fill: "#9DCDFF"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5713 33.686L32.6427 33.7572L32.5713 33.686Z",
    fill: "#6EB9F8"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2856 33.7573L17.3571 33.8285L17.2856 33.7573ZM23.4285 33.7573L23.4999 33.8285L23.4285 33.7573ZM26.4999 33.7573L26.5714 33.8285L26.4999 33.7573Z",
    fill: "#9DCDFF"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6431 33.7573L32.7145 33.8285L32.6431 33.7573Z",
    fill: "#6EB9F8"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2144 33.8286L17.2858 33.8998L17.2144 33.8286Z",
    fill: "#9DCDFF"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5002 33.8286L23.5716 33.8998L23.5002 33.8286ZM26.4288 33.8286L26.5002 33.8998L26.4288 33.8286ZM17.1431 33.8998L17.2145 33.971L17.1431 33.8998ZM23.5716 33.8998L23.6431 33.971L23.5716 33.8998ZM26.3574 33.8998L26.4288 33.971L26.3574 33.8998Z",
    fill: "#6EB9F8"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7144 33.8999L32.7858 33.9711L32.7144 33.8999Z",
    fill: "#9DCDFF"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0713 33.9707L17.1427 34.0419L17.0713 33.9707Z",
    fill: "#6EB9F8"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7617 33.9946L19.8114 34.0196L19.7617 33.9946Z",
    fill: "#9DCDFF"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8569 33.9707V34.0419H20.0712L19.8569 33.9707ZM20.7141 33.9707V34.0419H20.9284L20.7141 33.9707Z",
    fill: "#6EB9F8"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9761 33.9946L21.0257 34.0196L20.9761 33.9946Z",
    fill: "#9DCDFF"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6431 33.9707L23.7145 34.0419L23.6431 33.9707ZM26.2859 33.9707L26.3574 34.0419L26.2859 33.9707Z",
    fill: "#6EB9F8"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9761 33.9946L29.0257 34.0196L28.9761 33.9946Z",
    fill: "#9DCDFF"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0713 33.9707V34.0419H29.2856L29.0713 33.9707ZM29.9284 33.9707V34.0419H30.1427L29.9284 33.9707Z",
    fill: "#6EB9F8"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1904 33.9944L30.238 34.0182L30.1904 33.9944ZM32.7856 33.9707L32.8571 34.0419L32.7856 33.9707Z",
    fill: "#9DCDFF"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M17 34.042L17.0714 34.1132L17 34.042Z",
    fill: "#6EB9F8"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 34.042L19.5714 34.1132L19.5 34.042Z",
    fill: "#9DCDFF"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5713 34.042L19.6427 34.1132L19.5713 34.042ZM21.1427 34.042L21.2141 34.1132L21.1427 34.042Z",
    fill: "#6EB9F8"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2144 34.042L21.2858 34.1132L21.2144 34.042ZM23.6429 34.042L23.7144 34.1132L23.6429 34.042ZM28.7144 34.042L28.7858 34.1132L28.7144 34.042Z",
    fill: "#9DCDFF"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8335 34.0659L28.8811 34.0897L28.8335 34.0659ZM30.3335 34.0659L30.3811 34.0897L30.3335 34.0659Z",
    fill: "#6EB9F8"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4287 34.042L30.5001 34.1132L30.4287 34.042Z",
    fill: "#9DCDFF"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8569 34.042L32.9284 34.1132L32.8569 34.042Z",
    fill: "#6EB9F8"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M17 34.1133L17.0714 34.1845L17 34.1133ZM19.2857 34.1133L19.3571 34.1845L19.2857 34.1133Z",
    fill: "#9DCDFF"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3569 34.1133L19.4284 34.1845L19.3569 34.1133ZM21.3569 34.1133L21.4284 34.1845L21.3569 34.1133Z",
    fill: "#6EB9F8"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4287 34.1133L21.5001 34.1845L21.4287 34.1133ZM23.7144 34.1133L23.7859 34.1845L23.7144 34.1133ZM26.2144 34.1133L26.2859 34.1845L26.2144 34.1133ZM28.5001 34.1133L28.5716 34.1845L28.5001 34.1133Z",
    fill: "#9DCDFF"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5713 34.1133L28.6427 34.1845L28.5713 34.1133ZM30.5713 34.1133L30.6427 34.1845L30.5713 34.1133Z",
    fill: "#6EB9F8"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6431 34.1133L30.7145 34.1845L30.6431 34.1133Z",
    fill: "#9DCDFF"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9287 34.1133L33.0001 34.1845L32.9287 34.1133Z",
    fill: "#6EB9F8"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9287 34.1846L17.0001 34.2558L16.9287 34.1846ZM19.143 34.1846L19.2144 34.2558L19.143 34.1846Z",
    fill: "#9DCDFF"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 34.1846L21.5714 34.2558L21.5 34.1846Z",
    fill: "#6EB9F8"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5713 34.1846L21.6427 34.2558L21.5713 34.1846Z",
    fill: "#9DCDFF"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7856 34.1846V34.5406H23.8571L23.7856 34.1846Z",
    fill: "#6EB9F8"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1431 34.1846L26.2145 34.2558L26.1431 34.1846ZM28.3574 34.1846L28.4288 34.2558L28.3574 34.1846Z",
    fill: "#9DCDFF"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7144 34.1846L30.7858 34.2558L30.7144 34.1846Z",
    fill: "#6EB9F8"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7856 34.1846L30.8571 34.2558L30.7856 34.1846ZM32.9285 34.1846L32.9999 34.2558L32.9285 34.1846Z",
    fill: "#9DCDFF"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2144 34.1846V34.2558H36.4286L36.2144 34.1846Z",
    fill: "#6EB9F8"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4287 34.1846V34.2558H36.7859L36.4287 34.1846Z",
    fill: "#9DCDFF"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9285 39.9515C38.9291 40.1614 38.8914 40.456 39.0529 40.6205C39.2797 40.8513 40.2456 40.8296 40.3854 40.5105C40.5491 40.1367 40.4285 39.5005 40.4285 39.0971V35.8932C40.4285 35.5267 40.5659 34.8067 40.3551 34.4919C40.1739 34.2212 39.1938 34.2214 39.0127 34.4919C38.8571 34.7244 38.9285 35.1286 38.9285 35.3948C38.0141 33.9458 35.9323 33.8495 34.7266 35.0512C33.2257 36.5473 33.5596 39.5645 35.4999 40.5346C35.9953 40.7822 36.5918 40.9206 37.1428 40.835C37.8623 40.7233 38.3444 40.3492 38.9285 39.9515Z",
    fill: "#FEFEFF"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8569 34.1846V34.2558H37.2855L36.8569 34.1846Z",
    fill: "#9DCDFF"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3335 34.2083L37.3811 34.2321L37.3335 34.2083ZM43.4287 34.1846V34.2558H43.643L43.4287 34.1846Z",
    fill: "#6EB9F8"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6431 34.1846V34.2558H44.5717L43.6431 34.1846Z",
    fill: "#9DCDFF"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5712 34.1846V34.2558H44.7855L44.5712 34.1846ZM16.8569 34.2558L16.9284 34.327L16.8569 34.2558Z",
    fill: "#6EB9F8"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M19 34.2559L19.0714 34.3271L19 34.2559Z",
    fill: "#9DCDFF"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6431 34.2559L21.7145 34.3271L21.6431 34.2559Z",
    fill: "#6EB9F8"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7144 34.2559L21.7858 34.3271L21.7144 34.2559Z",
    fill: "#9DCDFF"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0713 34.2559L26.1427 34.3271L26.0713 34.2559Z",
    fill: "#6EB9F8"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2144 34.2559L28.2858 34.3271L28.2144 34.2559Z",
    fill: "#9DCDFF"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8569 34.2559L30.9284 34.3271L30.8569 34.2559Z",
    fill: "#6EB9F8"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9287 34.2559L31.0001 34.3271L30.9287 34.2559Z",
    fill: "#9DCDFF"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34.2559L33.0714 34.3271L33 34.2559ZM35.9762 34.2796L36.0238 34.3033L35.9762 34.2796Z",
    fill: "#6EB9F8"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0713 34.2559L36.1427 34.3271L36.0713 34.2559ZM37.4999 34.2559L37.5713 34.3271L37.4999 34.2559Z",
    fill: "#9DCDFF"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6191 34.2796L37.6667 34.3033L37.6191 34.2796ZM39.1429 34.2559V34.3271H40.2858L39.1429 34.2559ZM43.1906 34.2796L43.2381 34.3033L43.1906 34.2796Z",
    fill: "#6EB9F8"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2856 34.2559L43.3571 34.3271L43.2856 34.2559Z",
    fill: "#9DCDFF"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3573 34.2889C42.0973 34.5153 41.0011 36.0032 41.9569 37.1721C42.475 37.8057 43.3967 37.9682 44.143 38.1817C44.5063 38.2857 45.3124 38.502 45.2058 39.0258C45.1009 39.541 44.351 39.6546 43.9288 39.558C43.2575 39.4044 42.5472 38.0618 41.6861 38.7433C41.2915 39.0555 41.8761 39.8365 42.103 40.0627C42.84 40.7973 44.0142 40.9896 45.0002 40.7694C45.3774 40.6852 45.7703 40.5297 46.0688 40.2806C46.9102 39.5783 46.9052 38.3204 46.0713 37.6255C45.5719 37.2094 44.897 37.0676 44.2859 36.8901C43.9084 36.7804 43.0613 36.575 43.1345 36.0368C43.2048 35.5198 43.9493 35.406 44.3573 35.5041C44.8815 35.6303 44.9835 36.248 45.4327 36.3691C46.7234 36.7171 46.7564 35.5635 45.9935 34.8386C45.3324 34.2104 44.2198 34.1339 43.3573 34.2889Z",
    fill: "#FEFEFF"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9048 34.2793L44.9545 34.3043L44.9048 34.2793Z",
    fill: "#9DCDFF"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34.2559L45.0714 34.3271L45 34.2559ZM50.8571 34.2559V34.3271H51.5714L50.8571 34.2559Z",
    fill: "#6EB9F8"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8569 34.3267L18.9284 34.3979L18.8569 34.3267Z",
    fill: "#9DCDFF"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9287 34.3267L19.0001 34.3979L18.9287 34.3267ZM21.7859 34.3267L21.8573 34.3979L21.7859 34.3267Z",
    fill: "#6EB9F8"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8569 34.3267L21.9284 34.3979L21.8569 34.3267ZM28.0712 34.3267L28.1426 34.3979L28.0712 34.3267Z",
    fill: "#9DCDFF"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1431 34.3267L28.2145 34.3979L28.1431 34.3267ZM31.0002 34.3267L31.0716 34.3979L31.0002 34.3267Z",
    fill: "#6EB9F8"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0239 34.3745L33.0478 34.4219L33.0239 34.3745Z",
    fill: "#9DCDFF"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7144 34.3267L35.7858 34.3979L35.7144 34.3267Z",
    fill: "#6EB9F8"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7856 34.3267L35.8571 34.3979L35.7856 34.3267Z",
    fill: "#9DCDFF"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7856 34.3267L37.8571 34.3979L37.7856 34.3267ZM38.9999 34.3267L39.0714 34.3979L38.9999 34.3267Z",
    fill: "#6EB9F8"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2856 34.3267L40.3571 34.3979L40.2856 34.3267Z",
    fill: "#9DCDFF"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9287 34.3267L43.0001 34.3979L42.9287 34.3267Z",
    fill: "#6EB9F8"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34.3267L43.0714 34.3979L43 34.3267ZM45.1429 34.3267L45.2143 34.3979L45.1429 34.3267Z",
    fill: "#9DCDFF"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2144 34.3267L45.2858 34.3979L45.2144 34.3267ZM50.5001 34.3267L50.5715 34.3979L50.5001 34.3267Z",
    fill: "#6EB9F8"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6191 34.3506L50.6667 34.3744L50.6191 34.3506ZM51.762 34.3506L51.8096 34.3744L51.762 34.3506Z",
    fill: "#9DCDFF"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9048 34.3506L51.9544 34.3756L51.9048 34.3506Z",
    fill: "#6EB9F8"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7856 34.3979L16.8571 34.4692L16.7856 34.3979Z",
    fill: "#9DCDFF"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7856 34.3979L18.8571 34.4692L18.7856 34.3979Z",
    fill: "#6EB9F8"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9287 34.3979L22.0001 34.4692L21.9287 34.3979ZM26.0001 34.3979L26.0716 34.4692L26.0001 34.3979Z",
    fill: "#9DCDFF"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34.3979L28.0714 34.4692L28 34.3979ZM31.0714 34.3979L31.1429 34.4692L31.0714 34.3979Z",
    fill: "#6EB9F8"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1431 34.3979L31.2145 34.4692L31.1431 34.3979Z",
    fill: "#9DCDFF"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5713 34.3979L35.6427 34.4692L35.5713 34.3979Z",
    fill: "#6EB9F8"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6431 34.3979L35.7145 34.4692L35.6431 34.3979ZM37.9288 34.3979L38.0002 34.4692L37.9288 34.3979Z",
    fill: "#9DCDFF"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9287 34.3979L39.0001 34.4692L38.9287 34.3979Z",
    fill: "#6EB9F8"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3569 34.3979L40.4284 34.4692L40.3569 34.3979ZM42.7855 34.3979L42.8569 34.4692L42.7855 34.3979ZM45.3569 34.3979L45.4284 34.4692L45.3569 34.3979Z",
    fill: "#9DCDFF"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2144 34.3979L50.2858 34.4692L50.2144 34.3979Z",
    fill: "#6EB9F8"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2856 34.3979L50.3571 34.4692L50.2856 34.3979ZM52.0714 34.3979L52.1428 34.4692L52.0714 34.3979Z",
    fill: "#9DCDFF"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1429 34.3979L52.2144 34.4691L52.1429 34.3979ZM16.7144 34.4691L16.7858 34.5403L16.7144 34.4691Z",
    fill: "#6EB9F8"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6431 34.4692L18.7145 34.5404L18.6431 34.4692Z",
    fill: "#9DCDFF"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7144 34.4692L18.7858 34.5404L18.7144 34.4692ZM22.0001 34.4692L22.0715 34.5404L22.0001 34.4692ZM25.9286 34.4692L26.0001 34.5404L25.9286 34.4692Z",
    fill: "#6EB9F8"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8569 34.4692L27.9284 34.5404L27.8569 34.4692Z",
    fill: "#9DCDFF"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9287 34.4692L28.0001 34.5404L27.9287 34.4692Z",
    fill: "#6EB9F8"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2144 34.4692L31.2858 34.5404L31.2144 34.4692Z",
    fill: "#9DCDFF"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34.4692L33.0714 34.5404L33 34.4692ZM35.4286 34.4692L35.5 34.5404L35.4286 34.4692Z",
    fill: "#6EB9F8"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0713 34.4692L38.1427 34.5404L38.0713 34.4692ZM38.9284 34.4692L38.9999 34.5404L38.9284 34.4692ZM42.6427 34.4692L42.7141 34.5404L42.6427 34.4692ZM45.4999 34.4692L45.5713 34.5404L45.4999 34.4692Z",
    fill: "#9DCDFF"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0713 34.4692L50.1427 34.5404L50.0713 34.4692Z",
    fill: "#6EB9F8"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1431 34.4692L50.2145 34.5404L50.1431 34.4692Z",
    fill: "#9DCDFF"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2856 34.4692L52.3571 34.5404L52.2856 34.4692Z",
    fill: "#6EB9F8"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5713 34.5405L18.6427 34.6117L18.5713 34.5405ZM22.1427 34.5405L22.2141 34.6117L22.1427 34.5405ZM23.7141 34.5405L23.7856 34.6117L23.7141 34.5405ZM25.9284 34.5405L25.9999 34.6117L25.9284 34.5405ZM27.7856 34.5405L27.857 34.6117L27.7856 34.5405Z",
    fill: "#9DCDFF"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2856 34.5405L31.3571 34.6117L31.2856 34.5405ZM35.2856 34.5405L35.3571 34.6117L35.2856 34.5405ZM38.2142 34.5405L38.2856 34.6117L38.2142 34.5405ZM40.4285 34.5405V40.5211H40.4999V36.3917L40.4285 34.5405ZM42.4999 34.5405L42.5714 34.6117L42.4999 34.5405ZM45.6428 34.5405L45.7142 34.6117L45.6428 34.5405ZM49.8571 34.5405L49.9285 34.6117L49.8571 34.5405Z",
    fill: "#6EB9F8"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9287 34.5405L50.0001 34.6117L49.9287 34.5405ZM52.4287 34.5405L52.5001 34.6117L52.4287 34.5405Z",
    fill: "#9DCDFF"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6431 34.6118L16.7145 34.683L16.6431 34.6118Z",
    fill: "#6EB9F8"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 34.6118L18.5714 34.683L18.5 34.6118ZM22.2143 34.6118L22.2857 34.683L22.2143 34.6118ZM23.6429 34.6118L23.7143 34.683L23.6429 34.6118Z",
    fill: "#9DCDFF"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8569 34.6118L25.9284 34.683L25.8569 34.6118Z",
    fill: "#6EB9F8"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7144 34.6118L27.7858 34.683L27.7144 34.6118Z",
    fill: "#9DCDFF"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3569 34.6118L31.4284 34.683L31.3569 34.6118Z",
    fill: "#6EB9F8"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8569 34.6118L32.9284 34.683L32.8569 34.6118Z",
    fill: "#9DCDFF"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9287 34.6118L33.0001 34.683L32.9287 34.6118ZM35.143 34.6118L35.2144 34.683L35.143 34.6118Z",
    fill: "#6EB9F8"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2144 34.6118L35.2858 34.683L35.2144 34.6118ZM38.2858 34.6118L38.3572 34.683L38.2858 34.6118Z",
    fill: "#9DCDFF"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3569 34.6118L42.4284 34.683L42.3569 34.6118Z",
    fill: "#6EB9F8"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7144 34.6118L45.7858 34.683L45.7144 34.6118ZM49.7858 34.6118L49.8572 34.683L49.7858 34.6118Z",
    fill: "#9DCDFF"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5713 34.6118L52.6427 34.683L52.5713 34.6118Z",
    fill: "#6EB9F8"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4287 34.6826L18.5001 34.7538L18.4287 34.6826ZM22.2859 34.6826L22.3573 34.7538L22.2859 34.6826Z",
    fill: "#9DCDFF"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5713 34.6826L23.6427 34.7538L23.5713 34.6826Z",
    fill: "#6EB9F8"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8569 34.6826L25.9284 34.7538L25.8569 34.6826ZM27.6426 34.6826L27.7141 34.7538L27.6426 34.6826Z",
    fill: "#9DCDFF"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4287 34.6826L31.5001 34.7538L31.4287 34.6826ZM32.7859 34.6826L32.8573 34.7538L32.7859 34.6826ZM35.0716 34.6826L35.143 34.7538L35.0716 34.6826Z",
    fill: "#6EB9F8"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3569 34.6826L38.4284 34.7538L38.3569 34.6826ZM42.2855 34.6826L42.3569 34.7538L42.2855 34.6826Z",
    fill: "#9DCDFF"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8569 34.6826L45.9284 34.7538L45.8569 34.6826ZM49.6427 34.6826L49.7141 34.7538L49.6427 34.6826Z",
    fill: "#6EB9F8"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6431 34.6826L52.7145 34.7538L52.6431 34.6826Z",
    fill: "#9DCDFF"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7144 34.6826L52.7858 34.7538L52.7144 34.6826Z",
    fill: "#6EB9F8"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5713 34.7539L16.6427 34.8251L16.5713 34.7539ZM18.357 34.7539L18.4284 34.8251L18.357 34.7539ZM22.357 34.7539L22.4284 34.8251L22.357 34.7539ZM23.4284 34.7539L23.4999 34.8251L23.4284 34.7539Z",
    fill: "#9DCDFF"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 34.7539L23.5714 34.8251L23.5 34.7539ZM25.7857 34.7539L25.8571 34.8251L25.7857 34.7539Z",
    fill: "#6EB9F8"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5713 34.7539L27.6427 34.8251L27.5713 34.7539Z",
    fill: "#9DCDFF"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 34.7539L31.5714 34.8251L31.5 34.7539Z",
    fill: "#6EB9F8"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6431 34.7539L32.7145 34.8251L32.6431 34.7539ZM35.0002 34.7539L35.0716 34.8251L35.0002 34.7539ZM38.4288 34.7539L38.5002 34.8251L38.4288 34.7539ZM42.2145 34.7539L42.2859 34.8251L42.2145 34.7539Z",
    fill: "#9DCDFF"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9287 34.7539L46.0001 34.8251L45.9287 34.7539Z",
    fill: "#6EB9F8"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5713 34.7539L49.6427 34.8251L49.5713 34.7539Z",
    fill: "#9DCDFF"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7856 34.7539L52.8571 34.8251L52.7856 34.7539Z",
    fill: "#6EB9F8"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2856 34.8252L18.3571 34.8964L18.2856 34.8252ZM23.2856 34.8252L23.3571 34.8964L23.2856 34.8252Z",
    fill: "#9DCDFF"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3569 34.8252L23.4284 34.8964L23.3569 34.8252Z",
    fill: "#6EB9F8"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7856 34.8252L25.8571 34.8964L25.7856 34.8252ZM27.4999 34.8252L27.5714 34.8964L27.4999 34.8252ZM31.5714 34.8252L31.6428 34.8964L31.5714 34.8252ZM32.4999 34.8252L32.5714 34.8964L32.4999 34.8252Z",
    fill: "#9DCDFF"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5713 34.8252L32.6427 34.8964L32.5713 34.8252ZM34.857 34.8252L34.9284 34.8964L34.857 34.8252Z",
    fill: "#6EB9F8"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9287 34.8252L35.0001 34.8964L34.9287 34.8252ZM42.143 34.8252L42.2144 34.8964L42.143 34.8252Z",
    fill: "#9DCDFF"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M46 34.8252L46.0714 34.8964L46 34.8252Z",
    fill: "#6EB9F8"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8571 34.8252L52.9286 34.8964L52.8571 34.8252ZM16.5 34.8964L16.5714 34.9676L16.5 34.8964ZM18.2143 34.8964L18.2857 34.9676L18.2143 34.8964Z",
    fill: "#9DCDFF"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4287 34.8965L22.5001 34.9677L22.4287 34.8965ZM23.2144 34.8965L23.2859 34.9677L23.2144 34.8965ZM25.7144 34.8965L25.7859 34.9677L25.7144 34.8965Z",
    fill: "#6EB9F8"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6431 34.8965L31.7145 34.9677L31.6431 34.8965Z",
    fill: "#9DCDFF"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4287 34.8965L32.5001 34.9677L32.4287 34.8965ZM34.7859 34.8965L34.8573 34.9677L34.7859 34.8965Z",
    fill: "#6EB9F8"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5713 34.8965L38.6427 34.9677L38.5713 34.8965Z",
    fill: "#9DCDFF"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0713 34.8965L46.1427 34.9677L46.0713 34.8965Z",
    fill: "#6EB9F8"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3569 34.8965L49.4284 34.9677L49.3569 34.8965ZM52.9284 34.8965L52.9998 34.9677L52.9284 34.8965Z",
    fill: "#9DCDFF"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2144 34.9678L18.2858 35.039L18.2144 34.9678ZM22.5001 34.9678L22.5715 35.039L22.5001 34.9678Z",
    fill: "#6EB9F8"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0713 34.9678L23.1427 35.039L23.0713 34.9678ZM25.7141 34.9678L25.7856 35.039L25.7141 34.9678Z",
    fill: "#9DCDFF"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4287 34.9678L27.5001 35.039L27.4287 34.9678ZM31.643 34.9678L31.7144 35.039L31.643 34.9678Z",
    fill: "#6EB9F8"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 34.9678L32.3571 35.039L32.2856 34.9678Z",
    fill: "#9DCDFF"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7144 34.9678L34.7858 35.039L34.7144 34.9678Z",
    fill: "#6EB9F8"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6431 34.9678L38.7145 35.039L38.6431 34.9678ZM42.0002 34.9678L42.0716 35.039L42.0002 34.9678Z",
    fill: "#9DCDFF"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 34.9678L46.2145 35.039L46.1431 34.9678Z",
    fill: "#6EB9F8"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34.9678L53.0714 35.039L53 34.9678Z",
    fill: "#9DCDFF"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4287 35.0391L16.5001 35.1103L16.4287 35.0391ZM18.143 35.0391L18.2144 35.1103L18.143 35.0391ZM22.5716 35.0391L22.643 35.1103L22.5716 35.0391Z",
    fill: "#6EB9F8"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6904 35.0625L22.738 35.0863L22.6904 35.0625ZM22.9047 35.0625L22.9523 35.0863L22.9047 35.0625Z",
    fill: "#9DCDFF"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M23 35.0391L23.0714 35.1103L23 35.0391ZM27.3571 35.0391L27.4286 35.1103L27.3571 35.0391ZM31.7143 35.0391L31.7857 35.1103L31.7143 35.0391Z",
    fill: "#6EB9F8"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1431 35.0391L32.2145 35.1103L32.1431 35.0391Z",
    fill: "#9DCDFF"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2144 35.0391L32.2858 35.1103L32.2144 35.0391ZM34.6429 35.0391L34.7144 35.1103L34.6429 35.0391ZM38.7144 35.0391L38.7858 35.1103L38.7144 35.0391Z",
    fill: "#6EB9F8"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9287 35.0391L42.0001 35.1103L41.9287 35.0391Z",
    fill: "#9DCDFF"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2144 35.0391L46.2858 35.1103L46.2144 35.0391Z",
    fill: "#6EB9F8"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0716 35.0391L53.143 35.1103L53.0716 35.0391ZM16.4287 35.1103L16.5001 35.1815L16.4287 35.1103ZM18.0716 35.1103L18.143 35.1815L18.0716 35.1103Z",
    fill: "#9DCDFF"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6431 35.1099L25.7145 35.1811L25.6431 35.1099Z",
    fill: "#6EB9F8"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2856 35.1099L27.3571 35.1811L27.2856 35.1099Z",
    fill: "#9DCDFF"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8569 35.1099L31.9284 35.1811L31.8569 35.1099Z",
    fill: "#6EB9F8"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9761 35.1338L32.0257 35.1588L31.9761 35.1338Z",
    fill: "#9DCDFF"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0713 35.1099L32.1427 35.1811L32.0713 35.1099ZM34.5713 35.1099L34.6427 35.1811L34.5713 35.1099ZM41.857 35.1099L41.9284 35.1811L41.857 35.1099Z",
    fill: "#6EB9F8"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2144 35.1099L46.2858 35.1811L46.2144 35.1099ZM53.1429 35.1099L53.2144 35.1811L53.1429 35.1099Z",
    fill: "#9DCDFF"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3809 35.2285L16.4047 35.2759L16.3809 35.2285Z",
    fill: "#6EB9F8"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6431 35.1812L25.7145 35.2523L25.6431 35.1812Z",
    fill: "#9DCDFF"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2856 35.1812L27.3571 35.2523L27.2856 35.1812ZM38.7856 35.1812L38.8571 35.2523L38.7856 35.1812ZM41.7856 35.1812L41.8571 35.2523L41.7856 35.1812ZM46.2856 35.1812L46.3571 35.2523L46.2856 35.1812Z",
    fill: "#6EB9F8"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2144 35.1812L53.2858 35.2523L53.2144 35.1812Z",
    fill: "#9DCDFF"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M18 35.2524L18.0714 35.3236L18 35.2524ZM25.5952 35.2999L25.6191 35.3473L25.5952 35.2999Z",
    fill: "#6EB9F8"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2144 35.2524L27.2858 35.3236L27.2144 35.2524ZM34.5001 35.2524L34.5715 35.3236L34.5001 35.2524Z",
    fill: "#9DCDFF"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8569 35.2524L38.9284 35.3236L38.8569 35.2524Z",
    fill: "#6EB9F8"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7856 35.2524L41.8571 35.3236L41.7856 35.2524Z",
    fill: "#9DCDFF"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2856 35.2524L53.3571 35.3236L53.2856 35.2524Z",
    fill: "#6EB9F8"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3569 35.3237L16.4284 35.3949L16.3569 35.3237ZM34.4284 35.3237L34.4998 35.3949L34.4284 35.3237ZM38.8569 35.3237L38.9284 35.3949L38.8569 35.3237Z",
    fill: "#9DCDFF"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7144 35.3237L41.7858 35.3949L41.7144 35.3237Z",
    fill: "#6EB9F8"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3569 35.3237L46.4284 35.3949L46.3569 35.3237Z",
    fill: "#9DCDFF"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9287 35.395L18.0001 35.4662L17.9287 35.395Z",
    fill: "#6EB9F8"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5713 35.395L25.6427 35.4662L25.5713 35.395ZM27.1427 35.395L27.2141 35.4662L27.1427 35.395Z",
    fill: "#9DCDFF"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3569 35.395L34.4284 35.4662L34.3569 35.395Z",
    fill: "#6EB9F8"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7144 35.395L41.7858 35.4662L41.7144 35.395Z",
    fill: "#9DCDFF"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4287 35.395L46.5001 35.4662L46.4287 35.395Z",
    fill: "#6EB9F8"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3569 35.395L53.4284 35.4662L53.3569 35.395Z",
    fill: "#9DCDFF"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2856 35.4658L16.3571 35.537L16.2856 35.4658ZM27.1428 35.4658L27.2142 35.537L27.1428 35.4658Z",
    fill: "#6EB9F8"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M37 35.4658V35.537H37.2143L37 35.4658Z",
    fill: "#9DCDFF"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6431 35.4658L41.7145 35.537L41.6431 35.4658Z",
    fill: "#6EB9F8"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7617 35.4897L43.8114 35.5147L43.7617 35.4897Z",
    fill: "#9DCDFF"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8569 35.4658V35.537H44.2855L43.8569 35.4658Z",
    fill: "#6EB9F8"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3335 35.4895L44.3811 35.5133L44.3335 35.4895ZM46.4287 35.4658L46.5001 35.537L46.4287 35.4658ZM50.7144 35.4658V35.537H50.9287L50.7144 35.4658Z",
    fill: "#9DCDFF"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4287 35.4658L53.5001 35.537L53.4287 35.4658Z",
    fill: "#6EB9F8"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2856 35.5371L16.3571 35.6083L16.2856 35.5371Z",
    fill: "#9DCDFF"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8569 35.5371L17.9284 35.6083L17.8569 35.5371ZM25.4998 35.5371L25.5712 35.6083L25.4998 35.5371Z",
    fill: "#6EB9F8"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 35.5371L27.1427 35.6083L27.0713 35.5371ZM34.2856 35.5371L34.357 35.6083L34.2856 35.5371ZM36.6427 35.5371L36.7141 35.6083L36.6427 35.5371Z",
    fill: "#9DCDFF"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7617 35.561L36.8114 35.586L36.7617 35.561Z",
    fill: "#6EB9F8"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8572 35.5701C34.6059 35.9641 35.0539 39.8939 37.3572 39.491C39.6484 39.09 39.2275 35.1554 36.8572 35.5701Z",
    fill: "#017DFF"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4048 35.561L37.4545 35.586L37.4048 35.561Z",
    fill: "#6EB9F8"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5479 35.5608L37.5954 35.5846L37.5479 35.5608ZM41.6669 35.5846L41.6907 35.632L41.6669 35.5846ZM43.4288 35.5371L43.5002 35.6083L43.4288 35.5371Z",
    fill: "#9DCDFF"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5479 35.5608L43.5954 35.5846L43.5479 35.5608ZM44.5002 35.5371L44.5716 35.6083L44.5002 35.5371Z",
    fill: "#6EB9F8"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5713 35.5371L44.6427 35.6083L44.5713 35.5371ZM50.4046 35.5608L50.4522 35.5846L50.4046 35.5608Z",
    fill: "#9DCDFF"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5479 35.561L50.5954 35.5848L50.5479 35.561ZM51.1193 35.561L51.1669 35.5848L51.1193 35.561Z",
    fill: "#6EB9F8"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2621 35.5608L51.3096 35.5846L51.2621 35.5608ZM53.4287 35.5371L53.5001 35.6083L53.4287 35.5371ZM25.5239 35.6558L25.5478 35.7032L25.5239 35.6558Z",
    fill: "#9DCDFF"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 35.6084L27.1427 35.6796L27.0713 35.6084ZM34.2141 35.6084L34.2856 35.6796L34.2141 35.6084Z",
    fill: "#6EB9F8"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4287 35.6084L36.5001 35.6796L36.4287 35.6084Z",
    fill: "#9DCDFF"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 35.6084L36.5714 35.6796L36.5 35.6084ZM37.7143 35.6084L37.7857 35.6796L37.7143 35.6084ZM43.3571 35.6084L43.4286 35.6796L43.3571 35.6084ZM44.6429 35.6084L44.7143 35.6796L44.6429 35.6084Z",
    fill: "#6EB9F8"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7144 35.6084L44.7858 35.6796L44.7144 35.6084Z",
    fill: "#9DCDFF"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 35.6084L46.5714 35.6796L46.5 35.6084Z",
    fill: "#6EB9F8"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2144 35.6084L50.2858 35.6796L50.2144 35.6084Z",
    fill: "#9DCDFF"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3569 35.6084L51.4284 35.6796L51.3569 35.6084Z",
    fill: "#6EB9F8"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4287 35.6084L51.5001 35.6796L51.4287 35.6084Z",
    fill: "#9DCDFF"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5001 35.6084L53.5715 35.6796L53.5001 35.6084ZM16.2144 35.6796V35.8932H16.2858L16.2144 35.6796Z",
    fill: "#6EB9F8"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 35.6797L17.8571 35.7509L17.7856 35.6797Z",
    fill: "#9DCDFF"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2856 35.6797L36.3571 35.7509L36.2856 35.6797ZM37.8571 35.6797L37.9285 35.7509L37.8571 35.6797Z",
    fill: "#6EB9F8"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9287 35.6797L38.0001 35.7509L37.9287 35.6797Z",
    fill: "#9DCDFF"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5952 35.7271L41.6191 35.7745L41.5952 35.7271Z",
    fill: "#6EB9F8"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2144 35.6797L43.2858 35.7509L43.2144 35.6797Z",
    fill: "#9DCDFF"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7856 35.6797L44.8571 35.7509L44.7856 35.6797Z",
    fill: "#6EB9F8"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 35.6797L46.5714 35.7509L46.5 35.6797Z",
    fill: "#9DCDFF"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0713 35.6797L50.1427 35.7509L50.0713 35.6797Z",
    fill: "#6EB9F8"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5713 35.6797L51.6427 35.7509L51.5713 35.6797ZM53.4999 35.6797L53.5713 35.7509L53.4999 35.6797Z",
    fill: "#9DCDFF"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 35.751L17.8571 35.8222L17.7856 35.751Z",
    fill: "#6EB9F8"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M27 35.751L27.0714 35.8222L27 35.751Z",
    fill: "#9DCDFF"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1431 35.751L34.2145 35.8222L34.1431 35.751Z",
    fill: "#6EB9F8"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1431 35.751L36.2145 35.8222L36.1431 35.751Z",
    fill: "#9DCDFF"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35.751L38.0714 35.8222L38 35.751ZM44.8571 35.751L44.9286 35.8222L44.8571 35.751Z",
    fill: "#6EB9F8"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9287 35.751L50.0001 35.8222L49.9287 35.751Z",
    fill: "#9DCDFF"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9998 35.751L50.0712 35.8222L49.9998 35.751ZM51.6427 35.751L51.7141 35.8222L51.6427 35.751ZM53.5712 35.751L53.6427 35.8222L53.5712 35.751ZM25.4521 35.8697L25.476 35.9171L25.4521 35.8697ZM27.0236 35.8697L27.0474 35.9171L27.0236 35.8697ZM36.0712 35.8222L36.1427 35.8934L36.0712 35.8222ZM38.0712 35.8222L38.1427 35.8934L38.0712 35.8222Z",
    fill: "#6EB9F8"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1431 35.8218L38.2145 35.893L38.1431 35.8218ZM41.5716 35.8218V36.3914H41.6431L41.5716 35.8218Z",
    fill: "#9DCDFF"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1431 35.8218L43.2145 35.893L43.1431 35.8218ZM44.9288 35.8218L45.0002 35.893L44.9288 35.8218ZM46.5954 35.8693L46.6193 35.9167L46.5954 35.8693Z",
    fill: "#6EB9F8"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8572 35.8218L49.9286 35.893L49.8572 35.8218ZM51.7858 35.8218L51.8572 35.893L51.7858 35.8218ZM53.5715 35.8218L53.6429 35.893L53.5715 35.8218ZM16.2144 35.893L16.2858 35.9642L16.2144 35.893ZM17.7381 35.9405L17.762 35.9879L17.7381 35.9405Z",
    fill: "#9DCDFF"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0713 35.8931L34.1427 35.9643L34.0713 35.8931Z",
    fill: "#6EB9F8"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9287 35.8931L36.0001 35.9643L35.9287 35.8931ZM38.2144 35.8931L38.2859 35.9643L38.2144 35.8931ZM45.0001 35.8931L45.0716 35.9643L45.0001 35.8931ZM49.7859 35.8931L49.8573 35.9643L49.7859 35.8931ZM51.8573 35.8931L51.9287 35.9643L51.8573 35.8931Z",
    fill: "#9DCDFF"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7144 35.9645V36.0357H24.1429C23.2562 35.6648 21.6805 35.9645 20.7144 35.9645Z",
    fill: "#6EB9F8"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4287 35.9644V36.2491H25.5001L25.4287 35.9644ZM35.8573 35.9644L35.9287 36.0356L35.8573 35.9644Z",
    fill: "#9DCDFF"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2856 35.9644L38.3571 36.0356L38.2856 35.9644Z",
    fill: "#6EB9F8"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0713 35.9644V36.2491H43.1427L43.0713 35.9644Z",
    fill: "#9DCDFF"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35.9644L45.0714 36.0356L45 35.9644Z",
    fill: "#6EB9F8"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5713 35.9644V36.178H46.6427L46.5713 35.9644ZM49.7142 35.9644L49.7856 36.0356L49.7142 35.9644Z",
    fill: "#9DCDFF"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6431 35.9644L53.7145 36.0356L53.6431 35.9644ZM17.7383 36.083L17.7621 36.1305L17.7383 36.083Z",
    fill: "#6EB9F8"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5713 36.0356L20.6427 36.1068L20.5713 36.0356Z",
    fill: "#9DCDFF"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2144 36.0356L24.2858 36.1068L24.2144 36.0356Z",
    fill: "#6EB9F8"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9521 36.083L26.976 36.1304L26.9521 36.083Z",
    fill: "#9DCDFF"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M34 36.0356L34.0714 36.1068L34 36.0356Z",
    fill: "#6EB9F8"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7856 36.0356L35.8571 36.1068L35.7856 36.0356Z",
    fill: "#9DCDFF"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3569 36.0356L38.4284 36.1068L38.3569 36.0356Z",
    fill: "#6EB9F8"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0952 36.083L45.1191 36.1304L45.0952 36.083Z",
    fill: "#9DCDFF"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9287 36.0356L52.0001 36.1068L51.9287 36.0356Z",
    fill: "#6EB9F8"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6428 36.0356L53.7142 36.1068L53.6428 36.0356ZM24.2856 36.1068L24.3571 36.178L24.2856 36.1068ZM33.9999 36.1068L34.0714 36.178L33.9999 36.1068ZM38.4285 36.1068L38.4999 36.178L38.4285 36.1068Z",
    fill: "#9DCDFF"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6431 36.1069L49.7145 36.1781L49.6431 36.1069Z",
    fill: "#6EB9F8"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M52 36.1069L52.0714 36.1781L52 36.1069Z",
    fill: "#9DCDFF"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1431 36.1782V36.5342H16.2145L16.1431 36.1782Z",
    fill: "#6EB9F8"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4287 36.1782L20.5001 36.2494L20.4287 36.1782ZM24.3573 36.1782L24.4287 36.2494L24.3573 36.1782Z",
    fill: "#9DCDFF"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9287 36.1782V36.3918H27.0001L26.9287 36.1782ZM35.7144 36.1782L35.7859 36.2494L35.7144 36.1782Z",
    fill: "#6EB9F8"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 36.1782L38.5714 36.2494L38.5 36.1782Z",
    fill: "#9DCDFF"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0713 36.1782L45.1427 36.2494L45.0713 36.1782ZM46.5713 36.1782L46.6427 36.2494L46.5713 36.1782Z",
    fill: "#6EB9F8"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5713 36.1782L49.6427 36.2494L49.5713 36.1782Z",
    fill: "#9DCDFF"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3569 36.249L20.4284 36.3202L20.3569 36.249Z",
    fill: "#6EB9F8"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4287 36.249L24.5001 36.3202L24.4287 36.249Z",
    fill: "#9DCDFF"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9287 36.249L34.0001 36.3202L33.9287 36.249Z",
    fill: "#6EB9F8"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6431 36.249L35.7145 36.3202L35.6431 36.249Z",
    fill: "#9DCDFF"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1431 36.249L43.2145 36.3202L43.1431 36.249Z",
    fill: "#6EB9F8"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1431 36.249L45.2145 36.3202L45.1431 36.249ZM46.5002 36.249L46.5716 36.3202L46.5002 36.249Z",
    fill: "#9DCDFF"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5713 36.249L49.6427 36.3202L49.5713 36.249ZM52.0713 36.249L52.1427 36.3202L52.0713 36.249ZM53.7141 36.249L53.7856 36.3202L53.7141 36.249Z",
    fill: "#6EB9F8"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6431 36.3203V37.0323H17.7145L17.6431 36.3203ZM20.3574 36.3203V37.0323H20.4288L20.3574 36.3203ZM33.9288 36.3203L34.0002 36.3915L33.9288 36.3203Z",
    fill: "#9DCDFF"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5713 36.3203L38.6427 36.3915L38.5713 36.3203Z",
    fill: "#6EB9F8"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1431 36.3203L43.2145 36.3915L43.1431 36.3203ZM45.2145 36.3203L45.2859 36.3915L45.2145 36.3203ZM46.4288 36.3203L46.5002 36.3915L46.4288 36.3203ZM49.5002 36.3203L49.5716 36.3915L49.5002 36.3203ZM53.7383 36.3678L53.7621 36.4152L53.7383 36.3678Z",
    fill: "#9DCDFF"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 36.3916V37.1748H24.5714L24.5 36.3916ZM25.3571 36.3916V36.89H25.4286L25.3571 36.3916ZM35.5714 36.3916L35.6429 36.4628L35.5714 36.3916Z",
    fill: "#6EB9F8"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6431 36.3916L38.7145 36.4628L38.6431 36.3916Z",
    fill: "#9DCDFF"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5952 36.439L41.6191 36.4864L41.5952 36.439Z",
    fill: "#6EB9F8"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2144 36.3916L43.2858 36.4628L43.2144 36.3916Z",
    fill: "#9DCDFF"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3569 36.3916V36.4628H46.4284L45.3569 36.3916ZM49.4998 36.3916L49.5712 36.4628L49.4998 36.3916Z",
    fill: "#6EB9F8"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1431 36.3916L52.2145 36.4628L52.1431 36.3916Z",
    fill: "#9DCDFF"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8569 36.4629L33.9284 36.5341L33.8569 36.4629Z",
    fill: "#6EB9F8"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 36.4629L35.5714 36.5341L35.5 36.4629Z",
    fill: "#9DCDFF"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6431 36.4629L38.7145 36.5341L38.6431 36.4629Z",
    fill: "#6EB9F8"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2856 36.4629L43.3571 36.5341L43.2856 36.4629Z",
    fill: "#9DCDFF"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1431 36.4629L52.2145 36.5341L52.1431 36.4629Z",
    fill: "#6EB9F8"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1431 36.5342V36.819H16.2145L16.1431 36.5342ZM33.8811 36.5817L33.905 36.6291L33.8811 36.5817Z",
    fill: "#9DCDFF"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 36.5342L35.5714 36.6054L35.5 36.5342Z",
    fill: "#6EB9F8"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7144 36.5342L38.7858 36.6054L38.7144 36.5342Z",
    fill: "#9DCDFF"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4287 36.5342L43.5001 36.6054L43.4287 36.5342Z",
    fill: "#6EB9F8"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4287 36.5342L49.5001 36.6054L49.4287 36.5342Z",
    fill: "#9DCDFF"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7144 36.605L38.7858 36.6762L38.7144 36.605Z",
    fill: "#6EB9F8"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6431 36.605L41.7145 36.6762L41.6431 36.605ZM43.5002 36.605L43.5716 36.6762L43.5002 36.605Z",
    fill: "#9DCDFF"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5713 36.605L43.6427 36.6762L43.5713 36.605ZM49.4284 36.605L49.4999 36.6762L49.4284 36.605Z",
    fill: "#6EB9F8"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2144 36.605L52.2858 36.6762L52.2144 36.605Z",
    fill: "#9DCDFF"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7856 36.605V40.592H53.8571V37.8865L53.7856 36.605Z",
    fill: "#6EB9F8"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4287 36.6763L35.5001 36.7475L35.4287 36.6763Z",
    fill: "#9DCDFF"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6431 36.6763L41.7145 36.7475L41.6431 36.6763Z",
    fill: "#6EB9F8"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7144 36.6763L43.7858 36.7475L43.7144 36.6763Z",
    fill: "#9DCDFF"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7858 36.6763L43.8572 36.7475L43.7858 36.6763ZM52.2143 36.6763L52.2858 36.7475L52.2143 36.6763ZM33.8096 36.795L33.8334 36.8424L33.8096 36.795ZM35.4286 36.7475L35.5001 36.8187L35.4286 36.7475Z",
    fill: "#6EB9F8"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7856 36.7476L38.8571 36.8188L38.7856 36.7476ZM43.8571 36.7476L43.9285 36.8188L43.8571 36.7476Z",
    fill: "#9DCDFF"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9761 36.7715L44.0257 36.7965L43.9761 36.7715Z",
    fill: "#6EB9F8"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3569 36.7476V36.9611H49.4284L49.3569 36.7476Z",
    fill: "#9DCDFF"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1431 36.8188V37.1748H16.2145L16.1431 36.8188Z",
    fill: "#6EB9F8"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3809 36.8662L35.4047 36.9136L35.3809 36.8662Z",
    fill: "#9DCDFF"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7856 36.8188L38.8571 36.89L38.7856 36.8188Z",
    fill: "#6EB9F8"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7144 36.8188L41.7858 36.89L41.7144 36.8188ZM44.1429 36.8188L44.2144 36.89L44.1429 36.8188Z",
    fill: "#9DCDFF"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2144 36.8188L44.2858 36.89L44.2144 36.8188Z",
    fill: "#6EB9F8"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7856 36.8901V37.1037H33.8571L33.7856 36.8901Z",
    fill: "#9DCDFF"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7144 36.8901L41.7858 36.9613L41.7144 36.8901Z",
    fill: "#6EB9F8"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4048 36.9136L44.4544 36.9385L44.4048 36.9136Z",
    fill: "#9DCDFF"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 36.8901L44.5714 36.9613L44.5 36.8901Z",
    fill: "#6EB9F8"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2856 36.8901V37.4597H52.3571L52.2856 36.8901Z",
    fill: "#9DCDFF"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9287 36.9609V37.1745H27.0001L26.9287 36.9609ZM35.3811 37.0084L35.4049 37.0558L35.3811 37.0084Z",
    fill: "#6EB9F8"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8809 37.0084L38.9047 37.0558L38.8809 37.0084ZM41.7856 36.9609L41.8571 37.0321L41.7856 36.9609ZM44.6428 36.9609L44.7142 37.0321L44.6428 36.9609Z",
    fill: "#9DCDFF"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7141 36.9609L44.7855 37.0321L44.7141 36.9609ZM49.3569 36.9609V40.5208H49.4284C49.4284 39.5206 49.7433 37.8786 49.3569 36.9609ZM20.3569 37.0321L20.4284 37.1033L20.3569 37.0321Z",
    fill: "#6EB9F8"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8569 37.0322L44.9284 37.1034L44.8569 37.0322Z",
    fill: "#9DCDFF"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9761 37.0562L45.0257 37.0811L44.9761 37.0562Z",
    fill: "#6EB9F8"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4287 37.1035V37.3171H25.5001L25.4287 37.1035Z",
    fill: "#9DCDFF"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8569 37.1035V37.4595H38.9284L38.8569 37.1035ZM41.8569 37.1035L41.9284 37.1747L41.8569 37.1035Z",
    fill: "#6EB9F8"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0713 37.1035L45.1427 37.1747L45.0713 37.1035Z",
    fill: "#9DCDFF"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M45.143 37.1035L45.2144 37.1747L45.143 37.1035ZM20.4287 37.1747L20.5001 37.2459L20.4287 37.1747Z",
    fill: "#6EB9F8"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9521 37.2222L26.976 37.2696L26.9521 37.2222Z",
    fill: "#9DCDFF"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9287 37.1748L42.0001 37.246L41.9287 37.1748Z",
    fill: "#6EB9F8"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2856 37.1748L45.3571 37.246L45.2856 37.1748Z",
    fill: "#9DCDFF"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3572 37.1748L45.4286 37.246L45.3572 37.1748ZM17.7144 37.246L17.7858 37.3172L17.7144 37.246Z",
    fill: "#6EB9F8"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 37.2461L20.5714 37.3173L20.5 37.2461ZM35.2857 37.2461V37.7445H35.3571L35.2857 37.2461Z",
    fill: "#9DCDFF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M42 37.2461L42.0714 37.3173L42 37.2461ZM45.5 37.2461L45.5714 37.3173L45.5 37.2461Z",
    fill: "#6EB9F8"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7383 37.3647L17.7621 37.4122L17.7383 37.3647Z",
    fill: "#9DCDFF"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5713 37.3174L20.6427 37.3886L20.5713 37.3174Z",
    fill: "#6EB9F8"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6431 37.3174L20.7145 37.3886L20.6431 37.3174Z",
    fill: "#9DCDFF"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4287 37.3174V37.531H25.5001L25.4287 37.3174ZM42.0716 37.3174L42.143 37.3886L42.0716 37.3174Z",
    fill: "#6EB9F8"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6429 37.3174L45.7144 37.3886L45.6429 37.3174ZM16.2144 37.3886L16.2858 37.4598L16.2144 37.3886ZM23.0239 37.4361L23.0477 37.4835L23.0239 37.4361ZM24.4524 37.4361L24.4763 37.4835L24.4524 37.4361Z",
    fill: "#9DCDFF"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M27.024 37.4357L27.0478 37.4831L27.024 37.4357ZM42.143 37.3882L42.2145 37.4594L42.143 37.3882ZM45.7859 37.3882L45.8573 37.4594L45.7859 37.3882ZM16.2383 37.5069L16.2621 37.5543L16.2383 37.5069ZM42.2145 37.4594L42.2859 37.5306L42.2145 37.4594Z",
    fill: "#6EB9F8"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2856 37.4595L42.3571 37.5307L42.2856 37.4595ZM45.8571 37.4595L45.9285 37.5307L45.8571 37.4595Z",
    fill: "#9DCDFF"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9285 37.4595L45.9999 37.5307L45.9285 37.4595ZM52.2856 37.4595V37.6731H52.3571L52.2856 37.4595ZM17.7856 37.5307L17.8571 37.6019L17.7856 37.5307ZM24.4523 37.5782L24.4761 37.6256L24.4523 37.5782Z",
    fill: "#6EB9F8"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37.5308L27.0714 37.602L27 37.5308Z",
    fill: "#9DCDFF"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3569 37.5308L42.4284 37.602L42.3569 37.5308ZM45.9998 37.5308L46.0712 37.602L45.9998 37.5308Z",
    fill: "#6EB9F8"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 37.6021L17.8571 37.6732L17.7856 37.6021Z",
    fill: "#9DCDFF"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9521 37.6494L22.976 37.6968L22.9521 37.6494Z",
    fill: "#6EB9F8"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5239 37.6494L25.5478 37.6968L25.5239 37.6494Z",
    fill: "#9DCDFF"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8569 37.6021V37.958H38.9284L38.8569 37.6021Z",
    fill: "#6EB9F8"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 37.6021L42.5714 37.6732L42.5 37.6021ZM46.0714 37.6021L46.1429 37.6732L46.0714 37.6021Z",
    fill: "#9DCDFF"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 37.6733L27.1427 37.7445L27.0713 37.6733ZM42.5713 37.6733L42.6427 37.7445L42.5713 37.6733Z",
    fill: "#6EB9F8"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6428 37.6733L42.7142 37.7445L42.6428 37.6733ZM46.1428 37.6733L46.2142 37.7445L46.1428 37.6733ZM52.3094 37.7208L52.3333 37.7682L52.3094 37.7208ZM16.2856 37.7445L16.3571 37.8157L16.2856 37.7445Z",
    fill: "#9DCDFF"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8569 37.7441L17.9284 37.8153L17.8569 37.7441Z",
    fill: "#6EB9F8"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9287 37.7441L23.0001 37.8153L22.9287 37.7441ZM24.3811 37.7916L24.4049 37.839L24.3811 37.7916Z",
    fill: "#9DCDFF"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 37.7441L25.5714 37.8153L25.5 37.7441Z",
    fill: "#6EB9F8"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 37.7441L27.1427 37.8153L27.0713 37.7441Z",
    fill: "#9DCDFF"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7144 37.7441L42.7858 37.8153L42.7144 37.7441Z",
    fill: "#6EB9F8"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7856 37.7441L42.8571 37.8153L42.7856 37.7441ZM46.2142 37.7441L46.2856 37.8153L46.2142 37.7441Z",
    fill: "#9DCDFF"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2856 37.8154L16.3571 37.8866L16.2856 37.8154Z",
    fill: "#6EB9F8"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8569 37.8154L17.9284 37.8866L17.8569 37.8154Z",
    fill: "#9DCDFF"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8569 37.8154L22.9284 37.8866L22.8569 37.8154ZM27.1426 37.8154L27.2141 37.8866L27.1426 37.8154ZM42.9284 37.8154L42.9998 37.8866L42.9284 37.8154Z",
    fill: "#6EB9F8"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37.8154L43.0714 37.8866L43 37.8154ZM46.2857 37.8154L46.3571 37.8866L46.2857 37.8154Z",
    fill: "#9DCDFF"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2859 37.8154V40.5921H52.3573C52.3573 39.7967 52.5938 38.5469 52.2859 37.8154ZM17.9287 37.8866L18.0001 37.9578L17.9287 37.8866Z",
    fill: "#6EB9F8"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8569 37.8867L22.9284 37.9579L22.8569 37.8867Z",
    fill: "#9DCDFF"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3569 37.8867L24.4284 37.9579L24.3569 37.8867Z",
    fill: "#6EB9F8"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5713 37.8867L25.6427 37.9579L25.5713 37.8867ZM27.1427 37.8867L27.2141 37.9579L27.1427 37.8867ZM33.7856 37.8867V38.1003H33.857L33.7856 37.8867Z",
    fill: "#9DCDFF"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1191 37.9106L43.1688 37.9356L43.1191 37.9106Z",
    fill: "#6EB9F8"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2141 37.8867L43.2855 37.9579L43.2141 37.8867ZM46.3569 37.8867L46.4284 37.9579L46.3569 37.8867ZM16.3569 37.9579L16.4284 38.0291L16.3569 37.9579ZM17.9284 37.9579L17.9998 38.0291L17.9284 37.9579Z",
    fill: "#9DCDFF"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7856 37.958L22.8571 38.0292L22.7856 37.958ZM25.5951 38.0055L25.619 38.0529L25.5951 38.0055ZM27.2142 37.958L27.2856 38.0292L27.2142 37.958ZM35.3571 37.958L35.4285 38.0292L35.3571 37.958Z",
    fill: "#6EB9F8"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8809 38.0054L38.9047 38.0528L38.8809 38.0054Z",
    fill: "#9DCDFF"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3335 37.9814L43.3832 38.0064L43.3335 37.9814Z",
    fill: "#6EB9F8"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4287 37.958L43.5001 38.0292L43.4287 37.958Z",
    fill: "#9DCDFF"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4285 37.958L46.4999 38.0292L46.4285 37.958ZM16.3809 38.0767L16.4047 38.1241L16.3809 38.0767ZM17.9999 38.0292L18.0713 38.1004L17.9999 38.0292Z",
    fill: "#6EB9F8"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7856 38.0293L22.8571 38.1005L22.7856 38.0293ZM24.2856 38.0293L24.3571 38.1005L24.2856 38.0293ZM27.2142 38.0293L27.2856 38.1005L27.2142 38.0293ZM35.3809 38.0768L35.4047 38.1242L35.3809 38.0768Z",
    fill: "#9DCDFF"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5713 38.0293L43.6427 38.1005L43.5713 38.0293Z",
    fill: "#6EB9F8"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6904 38.0527L43.7401 38.0777L43.6904 38.0527Z",
    fill: "#9DCDFF"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7144 38.1001L22.7858 38.1713L22.7144 38.1001ZM24.2858 38.1001L24.3572 38.1713L24.2858 38.1001Z",
    fill: "#6EB9F8"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6431 38.1001L25.7145 38.1713L25.6431 38.1001Z",
    fill: "#9DCDFF"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2856 38.1001L27.3571 38.1713L27.2856 38.1001ZM33.8094 38.1476L33.8333 38.195L33.8094 38.1476ZM43.8571 38.1001L43.9285 38.1713L43.8571 38.1001Z",
    fill: "#6EB9F8"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9287 38.1001L44.0001 38.1713L43.9287 38.1001ZM46.5001 38.1001L46.5716 38.1713L46.5001 38.1001ZM16.4287 38.1713L16.5001 38.2425L16.4287 38.1713ZM18.0716 38.1713L18.143 38.2425L18.0716 38.1713ZM22.7144 38.1713L22.7859 38.2425L22.7144 38.1713Z",
    fill: "#9DCDFF"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6431 38.1714L25.7145 38.2426L25.6431 38.1714Z",
    fill: "#6EB9F8"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2856 38.1714L27.3571 38.2426L27.2856 38.1714Z",
    fill: "#9DCDFF"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7856 38.1714L31.8571 38.2426L31.7856 38.1714Z",
    fill: "#6EB9F8"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8569 38.1714V38.2426H32.0712L31.8569 38.1714Z",
    fill: "#9DCDFF"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0713 38.1714L32.1427 38.2426L32.0713 38.1714ZM38.7856 38.1714L38.857 38.2426L38.7856 38.1714ZM44.1189 38.1951L44.1665 38.2189L44.1189 38.1951Z",
    fill: "#6EB9F8"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2144 38.1714L44.2858 38.2426L44.2144 38.1714Z",
    fill: "#9DCDFF"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4287 38.2427L16.5001 38.3139L16.4287 38.2427ZM18.143 38.2427L18.2144 38.3139L18.143 38.2427ZM22.643 38.2427L22.7144 38.3139L22.643 38.2427Z",
    fill: "#6EB9F8"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2144 38.2427L24.2858 38.3139L24.2144 38.2427ZM27.3572 38.2427L27.4286 38.3139L27.3572 38.2427Z",
    fill: "#9DCDFF"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7144 38.2427L31.7858 38.3139L31.7144 38.2427Z",
    fill: "#6EB9F8"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1431 38.2427L32.2145 38.3139L32.1431 38.2427Z",
    fill: "#9DCDFF"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2144 38.2427L32.2858 38.3139L32.2144 38.2427ZM35.4286 38.2427L35.5001 38.3139L35.4286 38.2427Z",
    fill: "#6EB9F8"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7856 38.2427L38.8571 38.3139L38.7856 38.2427Z",
    fill: "#9DCDFF"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3569 38.2427L44.4284 38.3139L44.3569 38.2427Z",
    fill: "#6EB9F8"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4287 38.2427L44.5001 38.3139L44.4287 38.2427Z",
    fill: "#9DCDFF"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5713 38.2427L46.6427 38.3139L46.5713 38.2427ZM22.5713 38.3139L22.6427 38.3851L22.5713 38.3139ZM24.2141 38.3139L24.2856 38.3851L24.2141 38.3139Z",
    fill: "#6EB9F8"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7144 38.314L25.7858 38.3852L25.7144 38.314Z",
    fill: "#9DCDFF"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4287 38.314L27.5001 38.3852L27.4287 38.314ZM31.643 38.314L31.7144 38.3852L31.643 38.314Z",
    fill: "#6EB9F8"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 38.314L32.3571 38.3852L32.2856 38.314Z",
    fill: "#9DCDFF"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3569 38.314L32.4284 38.3852L32.3569 38.314Z",
    fill: "#6EB9F8"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8809 38.3615L33.9047 38.4089L33.8809 38.3615ZM35.4285 38.314L35.4999 38.3852L35.4285 38.314Z",
    fill: "#9DCDFF"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5713 38.314L44.6427 38.3852L44.5713 38.314Z",
    fill: "#6EB9F8"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6429 38.314L44.7143 38.3852L44.6429 38.314ZM46.5714 38.314L46.6429 38.3852L46.5714 38.314ZM16.5 38.3852L16.5714 38.4564L16.5 38.3852ZM18.2143 38.3852L18.2857 38.4564L18.2143 38.3852Z",
    fill: "#9DCDFF"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7144 38.3853L25.7858 38.4565L25.7144 38.3853ZM27.5001 38.3853L27.5715 38.4565L27.5001 38.3853Z",
    fill: "#6EB9F8"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6431 38.3853L31.7145 38.4565L31.6431 38.3853ZM32.4288 38.3853L32.5002 38.4565L32.4288 38.3853Z",
    fill: "#9DCDFF"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 38.3853L35.5714 38.4565L35.5 38.3853ZM38.7143 38.3853L38.7857 38.4565L38.7143 38.3853ZM44.7143 38.3853L44.7857 38.4565L44.7143 38.3853Z",
    fill: "#6EB9F8"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7856 38.3853L44.8571 38.4565L44.7856 38.3853Z",
    fill: "#9DCDFF"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6665 38.4326L46.6904 38.48L46.6665 38.4326Z",
    fill: "#6EB9F8"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2856 38.4565L18.3571 38.5277L18.2856 38.4565ZM22.4999 38.4565L22.5714 38.5277L22.4999 38.4565ZM24.1428 38.4565L24.2142 38.5277L24.1428 38.4565ZM25.7856 38.4565L25.8571 38.5277L25.7856 38.4565ZM27.4999 38.4565L27.5714 38.5277L27.4999 38.4565ZM31.5714 38.4565L31.6428 38.5277L31.5714 38.4565Z",
    fill: "#9DCDFF"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5713 38.4565L32.6427 38.5277L32.5713 38.4565ZM33.857 38.4565L33.9284 38.5277L33.857 38.4565Z",
    fill: "#6EB9F8"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 38.4565L35.5713 38.5277L35.4999 38.4565ZM38.7141 38.4565L38.7856 38.5277L38.7141 38.4565ZM44.9284 38.4565L44.9999 38.5277L44.9284 38.4565ZM16.5713 38.5277L16.6427 38.5989L16.5713 38.5277ZM18.357 38.5277L18.4284 38.5989L18.357 38.5277ZM22.4284 38.5277L22.4999 38.5989L22.4284 38.5277Z",
    fill: "#9DCDFF"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7856 38.5273L25.8571 38.5985L25.7856 38.5273Z",
    fill: "#6EB9F8"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5713 38.5273L27.6427 38.5985L27.5713 38.5273Z",
    fill: "#9DCDFF"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 38.5273L31.5714 38.5985L31.5 38.5273Z",
    fill: "#6EB9F8"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6431 38.5273L32.7145 38.5985L32.6431 38.5273Z",
    fill: "#9DCDFF"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7144 38.5273L32.7858 38.5985L32.7144 38.5273ZM35.5715 38.5273L35.6429 38.5985L35.5715 38.5273ZM38.6429 38.5273L38.7144 38.5985L38.6429 38.5273ZM45.0001 38.5273L45.0715 38.5985L45.0001 38.5273Z",
    fill: "#6EB9F8"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M46.643 38.5273L46.7144 38.5985L46.643 38.5273ZM18.4287 38.5985L18.5001 38.6697L18.4287 38.5985ZM22.3573 38.5985L22.4287 38.6697L22.3573 38.5985ZM24.0716 38.5985L24.143 38.6697L24.0716 38.5985ZM25.8573 38.5985L25.9287 38.6697L25.8573 38.5985ZM27.643 38.5985L27.7144 38.6697L27.643 38.5985Z",
    fill: "#9DCDFF"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4287 38.5986L31.5001 38.6698L31.4287 38.5986Z",
    fill: "#6EB9F8"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7856 38.5986L32.8571 38.6698L32.7856 38.5986Z",
    fill: "#9DCDFF"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8569 38.5986L32.9284 38.6698L32.8569 38.5986Z",
    fill: "#6EB9F8"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9287 38.5986L34.0001 38.6698L33.9287 38.5986ZM35.5716 38.5986L35.643 38.6698L35.5716 38.5986ZM38.643 38.5986L38.7144 38.6698L38.643 38.5986Z",
    fill: "#9DCDFF"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7145 38.5986V38.6698H42.8574L41.7145 38.5986ZM45.0716 38.5986L45.1431 38.6698L45.0716 38.5986ZM16.6431 38.6698L16.7145 38.741L16.6431 38.6698Z",
    fill: "#6EB9F8"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 38.6699L18.5714 38.7411L18.5 38.6699ZM22.2857 38.6699L22.3571 38.7411L22.2857 38.6699Z",
    fill: "#9DCDFF"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0713 38.6699L24.1427 38.7411L24.0713 38.6699ZM25.857 38.6699L25.9284 38.7411L25.857 38.6699Z",
    fill: "#6EB9F8"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7144 38.6699L27.7858 38.7411L27.7144 38.6699Z",
    fill: "#9DCDFF"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3569 38.6699L31.4284 38.7411L31.3569 38.6699ZM32.9284 38.6699L32.9998 38.7411L32.9284 38.6699ZM33.9521 38.7174L33.976 38.7648L33.9521 38.7174ZM35.6426 38.6699L35.7141 38.7411L35.6426 38.6699ZM38.5712 38.6699L38.6426 38.7411L38.5712 38.6699ZM41.5712 38.6699L41.6426 38.7411L41.5712 38.6699ZM42.9284 38.6699L42.9998 38.7411L42.9284 38.6699Z",
    fill: "#6EB9F8"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1427 38.6699L45.2141 38.7411L45.1427 38.6699ZM18.5713 38.7411L18.6427 38.8123L18.5713 38.7411Z",
    fill: "#9DCDFF"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1431 38.7412L22.2145 38.8124L22.1431 38.7412Z",
    fill: "#6EB9F8"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38.7412L24.0714 38.8124L24 38.7412ZM25.9286 38.7412L26 38.8124L25.9286 38.7412ZM27.7857 38.7412L27.8571 38.8124L27.7857 38.7412Z",
    fill: "#9DCDFF"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2858 38.7412L31.3572 38.8124L31.2858 38.7412ZM43.0001 38.7412L43.0715 38.8124L43.0001 38.7412ZM16.7144 38.8124L16.7858 38.8836L16.7144 38.8124ZM18.7144 38.8124L18.7858 38.8836L18.7144 38.8124ZM22.0715 38.8124L22.1429 38.8836L22.0715 38.8124ZM25.9286 38.8124L26.0001 38.8836L25.9286 38.8124ZM27.9286 38.8124L28.0001 38.8836L27.9286 38.8124Z",
    fill: "#6EB9F8"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2144 38.8125L31.2858 38.8837L31.2144 38.8125Z",
    fill: "#9DCDFF"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38.8125L33.0714 38.8837L33 38.8125Z",
    fill: "#6EB9F8"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 38.8125L34.0714 38.8837L33.9999 38.8125ZM35.7142 38.8125L35.7856 38.8837L35.7142 38.8125ZM38.4999 38.8125L38.5714 38.8837L38.4999 38.8125ZM41.4999 38.8125V39.0973H41.5714L41.4999 38.8125ZM42.9999 38.8125L43.0714 38.8837L42.9999 38.8125ZM45.2142 38.8125V39.0261H45.2856L45.2142 38.8125ZM16.7856 38.8837L16.8571 38.9549L16.7856 38.8837Z",
    fill: "#9DCDFF"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7856 38.8833L18.8571 38.9545L18.7856 38.8833ZM21.9285 38.8833L21.9999 38.9545L21.9285 38.8833Z",
    fill: "#6EB9F8"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38.8833L22.0714 38.9545L22 38.8833ZM23.9286 38.8833L24 38.9545L23.9286 38.8833Z",
    fill: "#9DCDFF"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38.8833L26.0714 38.9545L26 38.8833Z",
    fill: "#6EB9F8"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38.8833L28.0714 38.9545L28 38.8833Z",
    fill: "#9DCDFF"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0713 38.8833L31.1427 38.9545L31.0713 38.8833Z",
    fill: "#6EB9F8"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1431 38.8833L31.2145 38.9545L31.1431 38.8833ZM33.024 38.9308L33.0479 38.9782L33.024 38.9308Z",
    fill: "#9DCDFF"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38.8833L34.0714 38.9545L34 38.8833ZM35.7857 38.8833L35.8571 38.9545L35.7857 38.8833Z",
    fill: "#6EB9F8"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4287 38.8833L38.5001 38.9545L38.4287 38.8833Z",
    fill: "#9DCDFF"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0713 38.8833L43.1427 38.9545L43.0713 38.8833ZM46.7141 38.8833L46.7856 38.9545L46.7141 38.8833Z",
    fill: "#6EB9F8"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8569 38.9546L18.9284 39.0258L18.8569 38.9546Z",
    fill: "#9DCDFF"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9287 38.9546L19.0001 39.0258L18.9287 38.9546ZM21.8573 38.9546L21.9287 39.0258L21.8573 38.9546Z",
    fill: "#6EB9F8"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0713 38.9546L26.1427 39.0258L26.0713 38.9546ZM28.0713 38.9546L28.1427 39.0258L28.0713 38.9546Z",
    fill: "#9DCDFF"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1431 38.9546L28.2145 39.0258L28.1431 38.9546ZM31.0002 38.9546L31.0716 39.0258L31.0002 38.9546ZM35.8574 38.9546L35.9288 39.0258L35.8574 38.9546ZM38.3574 38.9546L38.4288 39.0258L38.3574 38.9546Z",
    fill: "#6EB9F8"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0713 38.9546L43.1427 39.0258L43.0713 38.9546Z",
    fill: "#9DCDFF"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8569 39.0259L16.9284 39.0971L16.8569 39.0259Z",
    fill: "#6EB9F8"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39.0259L19.0714 39.0971L19 39.0259Z",
    fill: "#9DCDFF"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7144 39.0259L21.7858 39.0971L21.7144 39.0259ZM23.8572 39.0259L23.9286 39.0971L23.8572 39.0259ZM26.0715 39.0259L26.1429 39.0971L26.0715 39.0259Z",
    fill: "#6EB9F8"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2144 39.0259L28.2858 39.0971L28.2144 39.0259Z",
    fill: "#9DCDFF"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8569 39.0259L30.9284 39.0971L30.8569 39.0259Z",
    fill: "#6EB9F8"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9287 39.0259L31.0001 39.0971L30.9287 39.0259Z",
    fill: "#9DCDFF"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39.0259L33.0714 39.0971L33 39.0259Z",
    fill: "#6EB9F8"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0713 39.0259L34.1427 39.0971L34.0713 39.0259Z",
    fill: "#9DCDFF"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9287 39.0259L36.0001 39.0971L35.9287 39.0259Z",
    fill: "#6EB9F8"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2856 39.0259L38.3571 39.0971L38.2856 39.0259Z",
    fill: "#9DCDFF"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1431 39.0259L43.2145 39.0971L43.1431 39.0259Z",
    fill: "#6EB9F8"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9287 39.0972L17.0001 39.1684L16.9287 39.0972ZM19.143 39.0972L19.2144 39.1684L19.143 39.0972Z",
    fill: "#9DCDFF"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5713 39.0972L21.6427 39.1684L21.5713 39.0972Z",
    fill: "#6EB9F8"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6431 39.0972L21.7145 39.1684L21.6431 39.0972ZM23.7859 39.0972L23.8574 39.1684L23.7859 39.0972Z",
    fill: "#9DCDFF"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1431 39.0972L26.2145 39.1684L26.1431 39.0972Z",
    fill: "#6EB9F8"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3569 39.0972L28.4284 39.1684L28.3569 39.0972Z",
    fill: "#9DCDFF"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4287 39.0972L28.5001 39.1684L28.4287 39.0972ZM30.7144 39.0972L30.7859 39.1684L30.7144 39.0972Z",
    fill: "#6EB9F8"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7856 39.0972L30.8571 39.1684L30.7856 39.0972ZM32.9285 39.0972L32.9999 39.1684L32.9285 39.0972Z",
    fill: "#9DCDFF"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0713 39.0972L34.1427 39.1684L34.0713 39.0972ZM35.9999 39.0972L36.0713 39.1684L35.9999 39.0972Z",
    fill: "#6EB9F8"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2144 39.0972L38.2858 39.1684L38.2144 39.0972Z",
    fill: "#9DCDFF"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 39.0972L41.5714 39.1684L41.5 39.0972Z",
    fill: "#6EB9F8"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1431 39.0972L43.2145 39.1684L43.1431 39.0972Z",
    fill: "#9DCDFF"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1431 39.0972L45.2145 39.1684L45.1431 39.0972Z",
    fill: "#6EB9F8"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M17 39.1685L17.0714 39.2397L17 39.1685ZM19.2857 39.1685L19.3571 39.2397L19.2857 39.1685Z",
    fill: "#9DCDFF"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3569 39.1685L19.4284 39.2397L19.3569 39.1685ZM21.3569 39.1685L21.4284 39.2397L21.3569 39.1685Z",
    fill: "#6EB9F8"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4287 39.1685L21.5001 39.2397L21.4287 39.1685ZM26.2144 39.1685L26.2859 39.2397L26.2144 39.1685ZM28.5001 39.1685L28.5716 39.2397L28.5001 39.1685Z",
    fill: "#9DCDFF"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5713 39.1685L28.6427 39.2397L28.5713 39.1685ZM30.5713 39.1685L30.6427 39.2397L30.5713 39.1685Z",
    fill: "#6EB9F8"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6431 39.1685L30.7145 39.2397L30.6431 39.1685ZM34.1431 39.1685L34.2145 39.2397L34.1431 39.1685ZM36.0716 39.1685L36.1431 39.2397L36.0716 39.1685Z",
    fill: "#9DCDFF"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0713 39.1685L38.1427 39.2397L38.0713 39.1685Z",
    fill: "#6EB9F8"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1431 39.1685L38.2145 39.2397L38.1431 39.1685ZM43.2145 39.1685L43.2859 39.2397L43.2145 39.1685ZM45.1431 39.1685L45.2145 39.2397L45.1431 39.1685Z",
    fill: "#9DCDFF"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M17 39.2393L17.0714 39.3105L17 39.2393Z",
    fill: "#6EB9F8"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4287 39.2393L19.5001 39.3105L19.4287 39.2393Z",
    fill: "#9DCDFF"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5479 39.263L19.5954 39.2867L19.5479 39.263ZM21.2145 39.2393L21.2859 39.3105L21.2145 39.2393Z",
    fill: "#6EB9F8"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2856 39.2393L21.3571 39.3105L21.2856 39.2393Z",
    fill: "#9DCDFF"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7144 39.2393L23.7858 39.3105L23.7144 39.2393Z",
    fill: "#6EB9F8"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7144 39.2393L28.7858 39.3105L28.7144 39.2393Z",
    fill: "#9DCDFF"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8335 39.2632L28.8811 39.287L28.8335 39.2632ZM30.3335 39.2632L30.3811 39.287L30.3335 39.2632Z",
    fill: "#6EB9F8"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4287 39.2393L30.5001 39.3105L30.4287 39.2393Z",
    fill: "#9DCDFF"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8569 39.2393L32.9284 39.3105L32.8569 39.2393ZM34.1426 39.2393L34.2141 39.3105L34.1426 39.2393Z",
    fill: "#6EB9F8"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1431 39.2393L36.2145 39.3105L36.1431 39.2393Z",
    fill: "#9DCDFF"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2144 39.2393L36.2858 39.3105L36.2144 39.2393ZM38.0001 39.2393L38.0715 39.3105L38.0001 39.2393Z",
    fill: "#6EB9F8"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5713 39.2393L41.6427 39.3105L41.5713 39.2393ZM43.2856 39.2393L43.357 39.3105L43.2856 39.2393ZM45.0713 39.2393L45.1427 39.3105L45.0713 39.2393ZM46.6665 39.2867L46.6904 39.3342L46.6665 39.2867Z",
    fill: "#9DCDFF"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0713 39.3105L17.1427 39.3817L17.0713 39.3105Z",
    fill: "#6EB9F8"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7144 39.3105L19.7858 39.3817L19.7144 39.3105Z",
    fill: "#9DCDFF"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 39.3343L19.8811 39.358L19.8335 39.3343ZM20.9287 39.3105L21.0001 39.3817L20.9287 39.3105Z",
    fill: "#6EB9F8"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0479 39.3345L21.0975 39.3594L21.0479 39.3345Z",
    fill: "#9DCDFF"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6431 39.3105L23.7145 39.3817L23.6431 39.3105ZM26.2859 39.3105L26.3574 39.3817L26.2859 39.3105Z",
    fill: "#6EB9F8"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M29 39.3105V39.3817H29.2143L29 39.3105Z",
    fill: "#9DCDFF"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2617 39.3343L29.3093 39.358L29.2617 39.3343ZM29.8569 39.3105V39.3817H30.0712L29.8569 39.3105Z",
    fill: "#6EB9F8"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1191 39.3343L30.1667 39.358L30.1191 39.3343ZM32.7858 39.3105L32.8572 39.3817L32.7858 39.3105ZM34.2144 39.3105L34.2858 39.3817L34.2144 39.3105ZM36.2858 39.3105L36.3572 39.3817L36.2858 39.3105Z",
    fill: "#9DCDFF"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8569 39.3105L37.9284 39.3817L37.8569 39.3105Z",
    fill: "#6EB9F8"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9287 39.3105L38.0001 39.3817L37.9287 39.3105Z",
    fill: "#9DCDFF"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5713 39.3105L41.6427 39.3817L41.5713 39.3105Z",
    fill: "#6EB9F8"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3569 39.3105L43.4284 39.3817L43.3569 39.3105Z",
    fill: "#9DCDFF"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4287 39.3105L43.5001 39.3817L43.4287 39.3105Z",
    fill: "#6EB9F8"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M45 39.3105L45.0714 39.3817L45 39.3105Z",
    fill: "#9DCDFF"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1431 39.3818L17.2145 39.453L17.1431 39.3818Z",
    fill: "#6EB9F8"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0713 39.3818V39.453H20.7856L20.0713 39.3818ZM23.5713 39.3818L23.6427 39.453L23.5713 39.3818Z",
    fill: "#9DCDFF"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3569 39.3818L26.4284 39.453L26.3569 39.3818Z",
    fill: "#6EB9F8"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7144 39.3818L32.7858 39.453L32.7144 39.3818ZM36.4286 39.3818L36.5001 39.453L36.4286 39.3818Z",
    fill: "#9DCDFF"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 39.3818L36.5714 39.453L36.5 39.3818ZM37.6905 39.4055L37.7381 39.4293L37.6905 39.4055Z",
    fill: "#6EB9F8"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 39.3818L43.5714 39.453L43.5 39.3818Z",
    fill: "#9DCDFF"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8569 39.3818L44.9284 39.453L44.8569 39.3818Z",
    fill: "#6EB9F8"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9287 39.3818L45.0001 39.453L44.9287 39.3818Z",
    fill: "#9DCDFF"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6431 39.3818L46.7145 39.453L46.6431 39.3818Z",
    fill: "#6EB9F8"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2144 39.4531L17.2858 39.5243L17.2144 39.4531ZM23.5001 39.4531L23.5715 39.5243L23.5001 39.4531Z",
    fill: "#9DCDFF"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4287 39.4531L26.5001 39.5243L26.4287 39.4531Z",
    fill: "#6EB9F8"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6431 39.4531L32.7145 39.5243L32.6431 39.4531Z",
    fill: "#9DCDFF"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2856 39.4531L34.3571 39.5243L34.2856 39.4531Z",
    fill: "#6EB9F8"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6431 39.4531L36.7145 39.5243L36.6431 39.4531Z",
    fill: "#9DCDFF"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7617 39.4766L36.8093 39.5003L36.7617 39.4766ZM37.4046 39.4766L37.4521 39.5003L37.4046 39.4766Z",
    fill: "#6EB9F8"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5479 39.4768L37.5954 39.5006L37.5479 39.4768ZM41.6431 39.4531L41.7145 39.5243L41.6431 39.4531ZM43.6431 39.4531L43.7145 39.5243L43.6431 39.4531Z",
    fill: "#9DCDFF"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7144 39.4531L43.7858 39.5243L43.7144 39.4531ZM44.6906 39.4768L44.7381 39.5006L44.6906 39.4768Z",
    fill: "#6EB9F8"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7856 39.4531L44.8571 39.5243L44.7856 39.4531ZM17.2856 39.5243L17.3571 39.5955L17.2856 39.5243ZM23.4285 39.5243L23.4999 39.5955L23.4285 39.5243ZM26.4999 39.5243L26.5714 39.5955L26.4999 39.5243Z",
    fill: "#9DCDFF"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6431 39.5244L32.7145 39.5956L32.6431 39.5244Z",
    fill: "#6EB9F8"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3569 39.5244L34.4284 39.5956L34.3569 39.5244ZM37.1189 39.5481L37.1664 39.5719L37.1189 39.5481Z",
    fill: "#9DCDFF"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6431 39.5244L41.7145 39.5956L41.6431 39.5244Z",
    fill: "#6EB9F8"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8569 39.5244V39.5956H44.0712L43.8569 39.5244Z",
    fill: "#9DCDFF"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0713 39.5244V39.5956H44.357L44.0713 39.5244Z",
    fill: "#6EB9F8"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3569 39.5244V39.5956H44.5712L44.3569 39.5244ZM46.5712 39.5244L46.6426 39.5956L46.5712 39.5244ZM17.3569 39.5956L17.4284 39.6668L17.3569 39.5956ZM23.3569 39.5956L23.4284 39.6668L23.3569 39.5956ZM26.5712 39.5956L26.6426 39.6668L26.5712 39.5956Z",
    fill: "#9DCDFF"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5713 39.5957L32.6427 39.6669L32.5713 39.5957Z",
    fill: "#6EB9F8"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7144 39.5957L41.7858 39.6669L41.7144 39.5957Z",
    fill: "#9DCDFF"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5713 39.5957L46.6427 39.6669L46.5713 39.5957Z",
    fill: "#6EB9F8"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4287 39.6665L17.5001 39.7377L17.4287 39.6665ZM23.2859 39.6665L23.3573 39.7377L23.2859 39.6665ZM26.643 39.6665L26.7144 39.7377L26.643 39.6665Z",
    fill: "#9DCDFF"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 39.6665L32.5714 39.7377L32.5 39.6665ZM34.4286 39.6665L34.5 39.7377L34.4286 39.6665Z",
    fill: "#6EB9F8"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 39.6665L46.5714 39.7377L46.5 39.6665ZM17.5 39.7377L17.5714 39.8089L17.5 39.7377ZM23.2143 39.7377L23.2857 39.8089L23.2143 39.7377Z",
    fill: "#9DCDFF"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7141 39.7378L26.7856 39.809L26.7141 39.7378ZM32.4284 39.7378L32.4999 39.809L32.4284 39.7378ZM34.4999 39.7378L34.5713 39.809L34.4999 39.7378ZM41.7856 39.7378L41.857 39.809L41.7856 39.7378ZM46.4999 39.7378L46.5713 39.809L46.4999 39.7378ZM17.5713 39.809L17.6427 39.8802L17.5713 39.809ZM23.1427 39.809L23.2141 39.8802L23.1427 39.809ZM26.7856 39.809L26.857 39.8802L26.7856 39.809ZM32.357 39.809L32.4284 39.8802L32.357 39.809Z",
    fill: "#6EB9F8"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5713 39.8091L34.6427 39.8803L34.5713 39.8091ZM41.857 39.8091L41.9284 39.8803L41.857 39.8091ZM46.4284 39.8091L46.4999 39.8803L46.4284 39.8091Z",
    fill: "#9DCDFF"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6431 39.8804L17.7145 39.9516L17.6431 39.8804ZM23.0716 39.8804L23.1431 39.9516L23.0716 39.8804ZM26.8574 39.8804L26.9288 39.9516L26.8574 39.8804Z",
    fill: "#6EB9F8"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2144 39.8804L32.2858 39.9516L32.2144 39.8804ZM34.6429 39.8804L34.7144 39.9516L34.6429 39.8804ZM41.9286 39.8804L42.0001 39.9516L41.9286 39.8804ZM46.3572 39.8804L46.4286 39.9516L46.3572 39.8804Z",
    fill: "#9DCDFF"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7144 39.9517L17.7858 40.0229L17.7144 39.9517Z",
    fill: "#6EB9F8"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 39.9517L17.8571 40.0229L17.7856 39.9517ZM22.9285 39.9517L22.9999 40.0229L22.9285 39.9517Z",
    fill: "#9DCDFF"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39.9517L23.0714 40.0229L23 39.9517ZM26.9286 39.9517L27 40.0229L26.9286 39.9517Z",
    fill: "#6EB9F8"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M27 39.9517L27.0714 40.0229L27 39.9517ZM32.1429 39.9517L32.2143 40.0229L32.1429 39.9517ZM34.7143 39.9517L34.7857 40.0229L34.7143 39.9517ZM38.7857 39.9517L38.8571 40.0229L38.7857 39.9517Z",
    fill: "#9DCDFF"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8569 39.9517L38.9284 40.0229L38.8569 39.9517Z",
    fill: "#6EB9F8"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39.9517L42.0714 40.0229L42 39.9517Z",
    fill: "#9DCDFF"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3569 39.9517L46.4284 40.0229L46.3569 39.9517Z",
    fill: "#6EB9F8"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8569 40.0225L17.9284 40.0937L17.8569 40.0225Z",
    fill: "#9DCDFF"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8569 40.0225L22.9284 40.0937L22.8569 40.0225Z",
    fill: "#6EB9F8"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 40.0225L27.1427 40.0937L27.0713 40.0225Z",
    fill: "#9DCDFF"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0713 40.0225L32.1427 40.0937L32.0713 40.0225Z",
    fill: "#6EB9F8"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7856 40.0225L34.8571 40.0937L34.7856 40.0225ZM38.7142 40.0225L38.7856 40.0937L38.7142 40.0225Z",
    fill: "#9DCDFF"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2858 40.0225L46.3573 40.0937L46.2858 40.0225ZM17.9287 40.0937L18.0001 40.1649L17.9287 40.0937Z",
    fill: "#6EB9F8"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7144 40.0938L22.7858 40.1649L22.7144 40.0938Z",
    fill: "#9DCDFF"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7856 40.0938L22.8571 40.1649L22.7856 40.0938ZM27.1428 40.0938L27.2142 40.1649L27.1428 40.0938Z",
    fill: "#6EB9F8"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9287 40.0938L32.0001 40.1649L31.9287 40.0938ZM34.8573 40.0938L34.9287 40.1649L34.8573 40.0938ZM38.643 40.0938L38.7144 40.1649L38.643 40.0938ZM42.143 40.0938L42.2144 40.1649L42.143 40.0938Z",
    fill: "#9DCDFF"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2144 40.0938L46.2858 40.1649L46.2144 40.0938Z",
    fill: "#6EB9F8"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0713 40.165L18.1427 40.2362L18.0713 40.165Z",
    fill: "#9DCDFF"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6431 40.165L22.7145 40.2362L22.6431 40.165Z",
    fill: "#6EB9F8"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2856 40.165L27.3571 40.2362L27.2856 40.165Z",
    fill: "#9DCDFF"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8569 40.165L31.9284 40.2362L31.8569 40.165Z",
    fill: "#6EB9F8"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9287 40.165L35.0001 40.2362L34.9287 40.165Z",
    fill: "#9DCDFF"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5713 40.165L38.6427 40.2362L38.5713 40.165Z",
    fill: "#6EB9F8"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2144 40.165L42.2858 40.2362L42.2144 40.165Z",
    fill: "#9DCDFF"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 40.165L46.2145 40.2362L46.1431 40.165ZM18.1431 40.2362L18.2145 40.3074L18.1431 40.2362Z",
    fill: "#6EB9F8"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2144 40.2363L18.2858 40.3075L18.2144 40.2363ZM22.5001 40.2363L22.5715 40.3075L22.5001 40.2363Z",
    fill: "#9DCDFF"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3569 40.2363L27.4284 40.3075L27.3569 40.2363Z",
    fill: "#6EB9F8"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4287 40.2363L27.5001 40.3075L27.4287 40.2363ZM31.7144 40.2363L31.7859 40.3075L31.7144 40.2363Z",
    fill: "#9DCDFF"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40.2363L35.0714 40.3075L35 40.2363ZM38.5 40.2363L38.5714 40.3075L38.5 40.2363Z",
    fill: "#6EB9F8"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2856 40.2363L42.3571 40.3075L42.2856 40.2363Z",
    fill: "#9DCDFF"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0714 40.2363L46.1428 40.3075L46.0714 40.2363ZM18.2856 40.3075L18.3571 40.3787L18.2856 40.3075Z",
    fill: "#6EB9F8"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3569 40.3076L22.4284 40.3788L22.3569 40.3076Z",
    fill: "#9DCDFF"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4287 40.3076L22.5001 40.3788L22.4287 40.3076ZM27.5001 40.3076L27.5716 40.3788L27.5001 40.3076Z",
    fill: "#6EB9F8"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5713 40.3076L31.6427 40.3788L31.5713 40.3076Z",
    fill: "#9DCDFF"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6431 40.3076L31.7145 40.3788L31.6431 40.3076ZM35.0716 40.3076L35.1431 40.3788L35.0716 40.3076Z",
    fill: "#6EB9F8"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1431 40.3076L35.2145 40.3788L35.1431 40.3076ZM38.3574 40.3076L38.4288 40.3788L38.3574 40.3076Z",
    fill: "#9DCDFF"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3573 40.3076L42.4287 40.3788L42.3573 40.3076ZM46.0001 40.3076L46.0716 40.3788L46.0001 40.3076ZM18.4287 40.3788L18.5001 40.45L18.4287 40.3788Z",
    fill: "#6EB9F8"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2144 40.3784L22.2858 40.4496L22.2144 40.3784Z",
    fill: "#9DCDFF"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2856 40.3784L22.3571 40.4496L22.2856 40.3784ZM27.6428 40.3784L27.7142 40.4496L27.6428 40.3784Z",
    fill: "#6EB9F8"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4287 40.3784L31.5001 40.4496L31.4287 40.3784Z",
    fill: "#9DCDFF"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 40.3784L31.5714 40.4496L31.5 40.3784Z",
    fill: "#6EB9F8"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2144 40.3784L35.2858 40.4496L35.2144 40.3784Z",
    fill: "#9DCDFF"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2856 40.3784L38.3571 40.4496L38.2856 40.3784Z",
    fill: "#6EB9F8"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 40.3784L42.5714 40.4496L42.5 40.3784ZM45.8571 40.3784L45.9286 40.4496L45.8571 40.3784Z",
    fill: "#9DCDFF"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5713 40.4497L18.6427 40.5209L18.5713 40.4497Z",
    fill: "#6EB9F8"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6431 40.4497L18.7145 40.5209L18.6431 40.4497ZM22.0716 40.4497L22.1431 40.5209L22.0716 40.4497Z",
    fill: "#9DCDFF"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7856 40.4497L27.8571 40.5209L27.7856 40.4497Z",
    fill: "#6EB9F8"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8569 40.4497L27.9284 40.5209L27.8569 40.4497ZM31.2855 40.4497L31.3569 40.5209L31.2855 40.4497Z",
    fill: "#9DCDFF"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3569 40.4497L31.4284 40.5209L31.3569 40.4497ZM35.2855 40.4497L35.3569 40.5209L35.2855 40.4497Z",
    fill: "#6EB9F8"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3569 40.4497L35.4284 40.5209L35.3569 40.4497ZM38.1426 40.4497L38.2141 40.5209L38.1426 40.4497Z",
    fill: "#9DCDFF"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2144 40.4497L38.2858 40.5209L38.2144 40.4497ZM42.5715 40.4497L42.6429 40.5209L42.5715 40.4497Z",
    fill: "#6EB9F8"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6431 40.4497L42.7145 40.5209L42.6431 40.4497ZM45.7145 40.4497L45.7859 40.5209L45.7145 40.4497Z",
    fill: "#9DCDFF"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7858 40.4497L45.8572 40.5209L45.7858 40.4497ZM18.7144 40.5209L18.7858 40.5921L18.7144 40.5209Z",
    fill: "#6EB9F8"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7856 40.521L18.8571 40.5922L18.7856 40.521ZM21.8571 40.521L21.9285 40.5922L21.8571 40.521Z",
    fill: "#9DCDFF"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9287 40.521L22.0001 40.5922L21.9287 40.521ZM27.9287 40.521L28.0001 40.5922L27.9287 40.521Z",
    fill: "#6EB9F8"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M28 40.521L28.0714 40.5922L28 40.521ZM31.1429 40.521L31.2143 40.5922L31.1429 40.521Z",
    fill: "#9DCDFF"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2144 40.521L31.2858 40.5922L31.2144 40.521ZM35.4286 40.521L35.5001 40.5922L35.4286 40.521Z",
    fill: "#6EB9F8"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 40.521L35.5714 40.5922L35.5 40.521ZM38 40.521L38.0714 40.5922L38 40.521Z",
    fill: "#9DCDFF"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0713 40.521L38.1427 40.5922L38.0713 40.521Z",
    fill: "#6EB9F8"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9287 40.521L39.0001 40.5922L38.9287 40.521Z",
    fill: "#9DCDFF"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7144 40.521L42.7858 40.5922L42.7144 40.521Z",
    fill: "#6EB9F8"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7856 40.521L42.8571 40.5922L42.7856 40.521Z",
    fill: "#9DCDFF"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6431 40.521L45.7145 40.5922L45.6431 40.521Z",
    fill: "#6EB9F8"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8569 40.521L47.9284 40.5922L47.8569 40.521Z",
    fill: "#9DCDFF"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9287 40.5923L19.0001 40.6635L18.9287 40.5923Z",
    fill: "#6EB9F8"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M19 40.5923L19.0714 40.6635L19 40.5923ZM21.6429 40.5923L21.7143 40.6635L21.6429 40.5923Z",
    fill: "#9DCDFF"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7144 40.5923L21.7858 40.6635L21.7144 40.5923ZM28.1429 40.5923L28.2144 40.6635L28.1429 40.5923Z",
    fill: "#6EB9F8"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2144 40.5923L28.2858 40.6635L28.2144 40.5923ZM30.9286 40.5923L31.0001 40.6635L30.9286 40.5923Z",
    fill: "#9DCDFF"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40.5923L31.0714 40.6635L31 40.5923ZM35.5714 40.5923L35.6429 40.6635L35.5714 40.5923Z",
    fill: "#6EB9F8"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6431 40.5923L35.7145 40.6635L35.6431 40.5923ZM37.8573 40.5923L37.9288 40.6635L37.8573 40.5923Z",
    fill: "#9DCDFF"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9287 40.5923L38.0001 40.6635L37.9287 40.5923ZM38.9287 40.5923L39.0001 40.6635L38.9287 40.5923Z",
    fill: "#6EB9F8"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3569 40.5923L40.4284 40.6635L40.3569 40.5923Z",
    fill: "#9DCDFF"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8569 40.5923L42.9284 40.6635L42.8569 40.5923Z",
    fill: "#6EB9F8"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9287 40.5923L43.0001 40.6635L42.9287 40.5923ZM45.4287 40.5923L45.5001 40.6635L45.4287 40.5923Z",
    fill: "#9DCDFF"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 40.5923L45.5714 40.6635L45.5 40.5923ZM47.8571 40.5923L47.9286 40.6635L47.8571 40.5923ZM49.2857 40.5923L49.3571 40.6635L49.2857 40.5923Z",
    fill: "#6EB9F8"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3569 40.5923L52.4284 40.6635L52.3569 40.5923ZM53.7141 40.5923L53.7855 40.6635L53.7141 40.5923Z",
    fill: "#9DCDFF"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1431 40.6636L19.2145 40.7348L19.1431 40.6636Z",
    fill: "#6EB9F8"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2617 40.6873L19.3093 40.7111L19.2617 40.6873ZM21.4284 40.6636L21.4998 40.7348L21.4284 40.6636Z",
    fill: "#9DCDFF"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 40.6636L21.5714 40.7348L21.5 40.6636ZM28.3571 40.6636L28.4286 40.7348L28.3571 40.6636Z",
    fill: "#6EB9F8"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4761 40.687L28.5236 40.7108L28.4761 40.687ZM30.6904 40.687L30.7379 40.7108L30.6904 40.687Z",
    fill: "#9DCDFF"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7856 40.6636L30.8571 40.7348L30.7856 40.6636ZM35.7142 40.6636L35.7856 40.7348L35.7142 40.6636Z",
    fill: "#6EB9F8"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8335 40.6873L35.8811 40.7111L35.8335 40.6873ZM37.7144 40.6636L37.7858 40.7348L37.7144 40.6636Z",
    fill: "#9DCDFF"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7856 40.6636L37.8571 40.7348L37.7856 40.6636ZM38.9999 40.6636L39.0714 40.7348L38.9999 40.6636Z",
    fill: "#6EB9F8"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2856 40.6636L40.3571 40.7348L40.2856 40.6636Z",
    fill: "#9DCDFF"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0713 40.6636L43.1427 40.7348L43.0713 40.6636Z",
    fill: "#6EB9F8"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1431 40.6636L43.2145 40.7348L43.1431 40.6636ZM45.2621 40.6873L45.3097 40.7111L45.2621 40.6873Z",
    fill: "#9DCDFF"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3569 40.6636L45.4284 40.7348L45.3569 40.6636ZM47.9284 40.6636L47.9998 40.7348L47.9284 40.6636Z",
    fill: "#6EB9F8"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2144 40.6636L49.2858 40.7348L49.2144 40.6636ZM52.4286 40.6636L52.5001 40.7348L52.4286 40.6636ZM53.6429 40.6636L53.7144 40.7348L53.6429 40.6636Z",
    fill: "#9DCDFF"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4761 40.7583L19.5257 40.7833L19.4761 40.7583Z",
    fill: "#6EB9F8"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6191 40.7583L19.6667 40.7821L19.6191 40.7583ZM21.1191 40.7583L21.1667 40.7821L21.1191 40.7583Z",
    fill: "#9DCDFF"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2144 40.7349L21.2858 40.8061L21.2144 40.7349ZM28.6429 40.7349L28.7144 40.8061L28.6429 40.7349Z",
    fill: "#6EB9F8"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7144 40.7349V40.8061H28.9286L28.7144 40.7349ZM30.4049 40.7586L30.4524 40.7824L30.4049 40.7586Z",
    fill: "#9DCDFF"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 40.7349L30.5714 40.8061L30.5 40.7349ZM35.9762 40.7586L36.0238 40.7824L35.9762 40.7586Z",
    fill: "#6EB9F8"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0713 40.7349L36.1427 40.8061L36.0713 40.7349ZM37.4999 40.7349L37.5713 40.8061L37.4999 40.7349Z",
    fill: "#9DCDFF"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5713 40.7349L37.6427 40.8061L37.5713 40.7349ZM39.1427 40.7349L39.2141 40.8061L39.1427 40.7349Z",
    fill: "#6EB9F8"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2144 40.7349V40.8061H40.2144L39.2144 40.7349Z",
    fill: "#9DCDFF"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2144 40.7349L40.2858 40.8061L40.2144 40.7349ZM43.2858 40.7349L43.3572 40.8061L43.2858 40.7349Z",
    fill: "#6EB9F8"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4048 40.7586L43.4524 40.7824L43.4048 40.7586ZM45 40.7349L45.0714 40.8061L45 40.7349Z",
    fill: "#9DCDFF"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0713 40.7349L45.1427 40.8061L45.0713 40.7349ZM48.0713 40.7349L48.1427 40.8061L48.0713 40.7349Z",
    fill: "#6EB9F8"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1431 40.7349V40.8061H49.0716L48.1431 40.7349Z",
    fill: "#9DCDFF"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1191 40.7586L49.1667 40.7824L49.1191 40.7586ZM52.5001 40.7349L52.5715 40.8061L52.5001 40.7349Z",
    fill: "#6EB9F8"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5713 40.7349V40.8061H53.5713L52.5713 40.7349Z",
    fill: "#9DCDFF"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5716 40.7349L53.643 40.8061L53.5716 40.7349ZM19.9287 40.8061V40.8773H20.2859L19.9287 40.8061Z",
    fill: "#6EB9F8"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2856 40.8057V40.8769H20.5714L20.2856 40.8057Z",
    fill: "#9DCDFF"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5713 40.8057V40.8769H20.9284L20.5713 40.8057ZM29.0713 40.8057V40.8769H29.4999L29.0713 40.8057Z",
    fill: "#6EB9F8"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 40.8057V40.8769H29.7857L29.5 40.8057Z",
    fill: "#9DCDFF"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7856 40.8057V40.8769H30.1428L29.7856 40.8057ZM36.2142 40.8057V40.8769H36.4285L36.2142 40.8057Z",
    fill: "#6EB9F8"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4761 40.8296L36.5236 40.8534L36.4761 40.8296ZM37.1189 40.8296L37.1665 40.8534L37.1189 40.8296Z",
    fill: "#9DCDFF"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2617 40.8294L37.3093 40.8532L37.2617 40.8294ZM43.5712 40.8057V40.8769H43.7855L43.5712 40.8057Z",
    fill: "#6EB9F8"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8335 40.8296L43.8811 40.8534L43.8335 40.8296ZM44.5478 40.8296L44.5954 40.8534L44.5478 40.8296Z",
    fill: "#9DCDFF"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6431 40.8057V40.8769H44.8574L44.6431 40.8057ZM59.9288 46.9286L60.0002 46.9998L59.9288 46.9286Z",
    fill: "#6EB9F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7942_24555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcashLogo);
export default __webpack_public_path__ + "static/media/gcash-logo.b7ca7d67c2f94979c740a6dc3108019b.svg";
export { ForwardRef as ReactComponent };